<template>
  <!--活动部件-小 -->
  <div class="createPlayStep new-input-box"> 
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="clickLocalStep()"
        >返回</jd-button
      >
      <span class="backBox_name"
        >{{ activityTitle }}</span
      >
    </div>
    <!--  活动条件表单部分 -->
    <div v-loading="fromLoading" class="secondstep">
      <div class="cardSet">
        <div class="form-content">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            class="backgroundForm"
            label-width="160px"
            :disabled="backgroundOpacity"
          >
        <jd-title
          label="基本信息"
          type="bold"
          style="margin-top: 0px; margin-left: 20px"
        ></jd-title>
        <el-form-item label="活动名称:" required>
          <el-input
            v-model="ruleForm.activityName"
            maxlength="15"
            show-word-limit
            placeholder="请填入"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间:" required>
          <div class="my_select_time">
            <el-date-picker
              v-model="activityTimeValue[0]"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :picker-options="pickerOptionsValue1"
              :default-time="defaultTime[0]"
              @change="activityTimeChange"
              :disabled="$route.query.valueRow && !isSave && !isCopy"
              placeholder="选择日期时间"
            >
            </el-date-picker>
            <span style="margin: 0 10px">-</span>
            <el-date-picker
              v-model="activityTimeValue[1]"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsValue2"
              @change="activityTimeChange"
              :default-time="defaultTime[1]"
              placeholder="选择日期时间"
            >
            </el-date-picker>
            <img
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
          <span class="lastTime" style="color: #666">
            活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
            <span style="color: #fe4d45">{{ timeOut }}</span> 小时
            <el-tooltip
              class="item"
              effect="light"
              content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
              placement="bottom"
            >
              <el-button type="text" style="width: 35px">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </span>
        </el-form-item>
        <!-- 礼包设置 -->
        <div class="crowd-container">
            <jd-title label="礼包设置" type="bold" style="margin-top: 0px; margin-left: 20px" />
            <el-form-item label="选择目标人群:" required style="margin-left: 30px">请选择需要投放的人群 </el-form-item>
            <div class="crowd">
              <jd-title label="系统自定义人群">
                <div slot="slotBox" >（系统自定义人群<span class="orangeColor">只支持单选</span
              >，并且无法和推荐人群同时选择；未关注店铺用户人群标签<span class="orangeColor">可多选</span>）</div>
              </jd-title>
              <div style="border: 1px solid #f0f0f0;margin-top: 16px;">
                <div class="crowd-tab">
                  <div class="crowd-tab-head">
                    <div class="crowd-tab-name">人群名称</div>
                    <div class="crowd-tab-sm" style="color:#000">人群说明</div>
                  </div>
                  <div class="crowd-tab-middle" v-for="item in personLab.customizeList" :key="item.labelId">
                    <div class="crowd-tab-name nameAlign">
                      <el-radio style="width:97%" @change="radioChange" v-model="ruleForm.modelIds" :disabled="isStart || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))"
                        :label="item.labelId">
                        <el-tooltip class="item" effect="light" :content="item.labelName" placement="top-start">
                          <el-button class="overHiddle">{{ item.labelName }}</el-button>
                        </el-tooltip>
                      </el-radio>
                    </div>

                    <div class="crowd-tab-sm" :class="{ descbox: item.labelVal }">
                      {{ item.labelDesc }}
                      <template v-if="!disableVF">
                        <div class="dx" v-if="item.labelVal && item.labelVal.length > 1">
                          <el-checkbox :disabled="disableVF || isStart || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))" style="display: inline-block"
                            v-model="verCheckAll" @change="handleCheckedChange">全选</el-checkbox>
                          <el-checkbox-group @change="handleChang" style="display: inline-block;margin-left: 30px;"
                            v-model="ruleForm.vermicelliVal">
                            <el-checkbox :disabled="disableVF || isStart || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))" v-for="item1 in item.labelVal"
                              :label="item1.level" :key="item1.level">{{
        item1.desc
      }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="crowd">
              <jd-title label="推荐人群">
                <div slot="slotBox">
                  （推荐人群<span class="orangeColor">只支持单选</span>，并且无法和系统自定义人群同时选择；店铺会员人群标签<span class="orangeColor">等级0-5可多选</span>，但<span class="orangeColor">跟非会员选项互斥</span>）
                </div>
              </jd-title>
              <div style="border: 1px solid #f0f0f0;margin-top: 16px;">
                <div class="crowd-tab">
                  <div class="crowd-tab-head">
                    <div class="crowd-tab-name">人群名称</div>
                    <div class="crowd-tab-sm" style="color:#000">人群说明</div>
                  </div>
                  <div class="crowd-tab-middle" v-for="info in personLab.recommendList" :key="info.labelId">
                    <div class="crowd-tab-name nameAlign">
                      <el-radio style="width:97%" :disabled="isStart || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))" @change="radioChange" v-model="ruleForm.modelIds"
                        :label="info.labelId">
                        <el-tooltip class="item" effect="light" :content="info.labelName" placement="top-start">
                          <el-button class="overHiddle">{{ info.labelName }}</el-button>
                        </el-tooltip>
                      </el-radio>
                    </div>
                    <div class="crowd-tab-sm descbox" :class="{ descbox: info.labelVal && info.labelVal.length > 1 }">
                      {{ info.labelDesc }}
                      <template v-if="!disableCUS">
                        <div class="dx" v-if="info.labelVal && info.labelVal.length > 1">
                          <el-checkbox v-show=" info.labelName !== '店铺会员'" :disabled="disableCUS || isStart || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))" style="display: inline-block;" v-model="starCheckAll" @change="handleCheckedStarChange"
                          >全选</el-checkbox
                        >
                          <el-checkbox-group @change="handleChang" style="display: inline-block;"
                            v-model="ruleForm.starVal">
                            <div v-for="item1 in info.labelVal" :key="item1.level" style="display: inline-block;">
                              <el-checkbox  v-if='item1.level == -1' :label="item1.level"  :disabled="disableCUS || isStart ||openClick == 1 || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))" > {{
                                item1.desc
                              }}</el-checkbox>
                              <el-checkbox  v-else :label="item1.level"  :disabled="disableCUS || isStart || openClick == 2 || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))" >{{
                                item1.desc
                              }}</el-checkbox>
                            </div>
                            </el-checkbox-group>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

        <!-- 加购礼包-加购商品 -->
        <el-form-item label="加购商品:" required v-if="activityData.id === 75" style="margin-left:-15px">
          <el-button :disabled="isStart" style="width: 155px; margin: 0 15px;display: inline-block;"
            :class="[{ 'add_btn1': ruleForm.exposureSwitch },{'global-view-btn':backgroundOpacity}]"  @click="isChange">
            {{ "添加商品" + "(" + skuList.length + "/10" + ")" }}
          </el-button>
          <draggable v-if="skuList.length > 0" v-model="skuList" chosen-class="chosen" :scroll="true"
            animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd"
            style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;" filter=".unmover">
            <transition-group type="transition">
              <div v-for="(item, index) in skuList" :key="item.skuId"
                style="display: inline-block; position: relative" class="show_upImg2" :class="isStart ? 'unmover' : ''">
                <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                <div class="delectPosible" v-if="!isStart">
                  <span class="delectSort">拖动排序</span>
                  <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
                </div>
              </div>
            </transition-group>
          </draggable>
        </el-form-item>

        <!-- 发送人数 -->
        <el-form-item label="发送人数:" style="margin-left:-15px">
          <el-input v-model="sendCount"
             @change="handleSendCount" 
            placeholder="请输入" style="width: 140px" :disabled="isStart || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))">
          </el-input>
          <el-tooltip class="item" effect="light" content="奖品发放总人数设置" placement="bottom">
            <el-button type="text" style="margin-left: 6px;width: 35px;">
              <i class="el-icon-question" style="color: #ccc;"></i>
            </el-button>
          </el-tooltip>
          <el-checkbox v-model="ruleForm.ruleDTO.isOutClose" :disabled="isStart || (activityData.id == 74 && (valueRow ? valueRow.status == 2 : false))" style="margin-left:7px">
            勾选奖品发完自动结束活动
          </el-checkbox>
        </el-form-item>

        <!-- 奖品设置 -->
        <el-form-item label="奖品设置:"   style="margin-left:-15px">
          <div class="shopSetLeft-connet">
            <div class="shopSet-left">
              <gifBagStyle 
                :giftPrizeType="giftPrizeType"
                :libaoList="libaoList" 
                :sendCount="sendCount"
                @handleClickPoint="handleClickPoint" 
                @closePrize="closePrize"
                @handleRemovePoint="handleRemovePoint" 
                @setDonCoupon="setDonCoupon"/>
            </div>
          </div>
        </el-form-item>

        <!-- 弹窗模板 -->
        <el-form-item label="弹窗模板:"  style="margin-left:-15px">
                  <el-radio
                    @change="handleTemplateTypeChange"
                    v-model="cardFaces[acrdIndex].templateType"
                    :label="0"
                  >
                    系统模板
                  </el-radio>
                  <el-radio
                    @change="handleTemplateTypeChange"
                    v-model="cardFaces[acrdIndex].templateType"
                    :label="1"
                  >
                    自定义模板
                  </el-radio>
                  <div>
                    <div
                      class="template-tabs"
                      v-if="cardFaces[acrdIndex].templateType == 0"
                    >
                      <!-- active: cardFace.activeTabIndex == tabIndex, -->
                      <div
                        v-for="(tab, tabIndex) in templateTabs"
                        :key="tabIndex"
                        class="tab-item"
                        :class="{
                          active: cardFaces[acrdIndex].activeTabId == tab.id,
                          first: tabIndex === 0,
                          last: tabIndex === templateTabs.length - 1,
                        }"
                        @click="handleTabClick(tab.id, acrdIndex)"
                      >
                        {{ tab.name }}
                      </div>
                    </div>
                    <div v-if="cardFaces[acrdIndex].templateType == 1">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => onBeforeUpload2(file, acrdIndex)"
                        :on-success="(res) => onUploadSuccess2(res, acrdIndex)"
                        :disabled="backgroundOpacity"
                      >
                        <jd-button type="blue" :disabled="backgroundOpacity"
                          >上传图片</jd-button
                        >
                      </el-upload>
                      <span class="ml10 c_999" v-if="activityDataID == 56"
                        >格式：jpg、png、gif，尺寸：宽630px * 高788px</span
                      >
                      <span class="ml10 c_999" v-else>
                        格式：jpg、png、gif，尺寸：宽630px * 高788px
                      </span>
                    </div>
                    <!-- 选择模板 -->
                    <div
                      class="template-container"
                      v-if="cardFaces[acrdIndex].templateType == 0"
                    >
                      <div
                        class="template-item"
                        v-for="(item, templateIndex) in templateList"
                        :key="item.id"
                        @click="
                          selectTemplate(acrdIndex, templateIndex, item.id, item)
                        "
                      >
                        <img :src="item.templateUrl" class="template-image" />
                        <div class="template-name">
                          {{ item.templateName }}
                        </div>
                        <img
                          v-if="cardFaces[acrdIndex].templateId == item.id"
                          class="template-selected-icon"
                          src="https://yunqi-hd-public.tos-cn-beijing.volces.com/image/activityBtn/temp_selected.png"
                        />
                      </div>
                    </div>
                    <!-- 自定义模板列表展示 -->
                    <div
                      class="template-container"
                      v-if="cardFaces[acrdIndex].templateType == 1"
                    >
                      <div
                        class="template-item"
                        v-for="(item, templateIndex) in customTemplateList"
                        :key="item.id || templateIndex"
                        @click="
                          selectCustomTemplate(acrdIndex, templateIndex, item)
                        "
                      >
                        <div class="template-item-wrapper">
                          <img :src="item.imageUrl" class="template-image" />
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                            class="delectIcom"
                            @click.stop="deleteCustomTemplate(item.id)"
                          />
                        </div>
                        <div class="template-name">
                          {{ item.imageName }}
                        </div>
                        <img
                          v-if="cardFaces[acrdIndex].cusTemplateJSON == item.imageUrl"
                          class="template-selected-icon"
                          src="https://yunqi-hd-public.tos-cn-beijing.volces.com/image/activityBtn/temp_selected.png"
                        />
                      </div>
                    </div>
                  </div>
        </el-form-item>
          <!-- 新增字段 -->
          <el-form-item label="是否重点活动:" required>
            <div class="flexc-cen-x mt10">
              <el-radio-group v-model="isKeyActivity" :disabled="activityData.status&&!activityData.isCopy">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>
                    大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                  </div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="活动投放位置:" required>
            <el-checkbox-group v-model="placementPosition" :disabled="activityData.status&&!activityData.isCopy">
              <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
              <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
              <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
              <el-checkbox label="SHOP">店铺</el-checkbox>
              <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
              <el-checkbox label="OTHER">其他渠道</el-checkbox>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </el-checkbox-group>
          </el-form-item>
         </el-form>
        </div>

        <!-- 预览图容器移到右侧 -->
              <div class="preview-image-wrapper">
                <!-- 预览展示 -->
                <div class="preview-prize-list">
                  <div class="preview-prize-item" v-if="sceneList[0].jfcheck">
                    <span class="prize-label">店铺积分</span>
                    <span class="prize-value">{{ sceneList[0].jfprice }}</span>
                  </div>
                  <div class="preview-prize-item" v-if="sceneList[0].jdcheck">
                    <span class="prize-label">京豆</span>
                    <span class="prize-value">{{ sceneList[0].jdprice }}</span>
                  </div>
                  <div class="preview-prize-item" v-if="sceneList[0].dqcheck">
                    <span class="prize-label">东券</span>
                    <span class="prize-value">{{ sceneList[0].dqprice }}元</span>
                  </div>
                  <div class="preview-prize-item" v-if="sceneList[0].jqcheck">
                    <span class="prize-label">京券</span>
                    <span class="prize-value">{{ sceneList[0].jqprice }}元</span>
                  </div>
                </div>
                <img
                  :src="previewImageSrc"
                  alt="预览图"
                  class="preview-image"
                />
                <img
                  class="previewBg"
                  v-if="
                    activityDataID == 74
                  "
                  :src="cardFaces[acrdIndex].imageUrl"
                />
                <div class="previewTip">
                  图为预览效果,以实际投放位置效果为准
                </div>
              </div>
      </div>
    </div>
    <div class="create_bottom">
      <jd-button style="margin-right: 8px" @click="clickLocalStep()">
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
       <jd-button style="margin-right: 8px" v-if="hasDraftBtn" @click="saveDraft"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button type="break" @click="preSave" v-preventReClick
          >保存并完成设置</jd-button
        >
        <el-popover
          v-if="false"
          placement="top-start"
          width="300"
          trigger="hover"
          content="因官方改造，小部件功能下架，如需实现类似功能可联系客服了解店铺装修定制业务~"
        >
          <jd-button type="disabledGrey" slot="reference" disabled
            >保存并完成设置</jd-button
          >
        </el-popover>
      </template>
    </div>
    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false" style="margin-right: 8px"
          >取消</jd-button
        >
        <jd-button @click="handleDialogCloseAnoth()" type="blue"
          >确定</jd-button
        >
      </div>
    </el-dialog>
    <selectActivityDialog
      :isShow="showSelectActivity"
      :activityIds="63"
      @selectActivity="handlerSelectActivity"
      @close="handleSelectActivityClose"
    />
    <!-- 选择人群弹窗 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList"
      @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>
     <!-- 选择商品弹窗 -->
    <select-goods
      v-if="isShowGoods"
      :isShow="isShowGoods"
      :selectGoods="skuList"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
      :limitNum="10"
      :isLimit="true"
    ></select-goods>
  </div>
</template>

<script>
import {
  purchaseActivityDetail,
  fullGiftDetail,
  sellerImage,
  orderRankDetail,
  getGiftBagTemplate,
  getGiftBagList,
  getPersonLabelList,
  createShopGift,
  editShopGift,
  updateCommon,
  giftBagEide
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import selectActivityDialog from "@/views/interactiveMarketing/cardManage/components/selectActivity.vue";
import gifBagStyle from "./components/gifBagStyle.vue";
import previewCard1 from "@/views/interactiveMarketing/cardManage/components/previewCard1.vue";
import previewCard2 from "@/views/interactiveMarketing/cardManage/components/previewCard2.vue";
import previewCard3 from "@/views/interactiveMarketing/cardManage/components/previewCard3.vue";
import previewCard4 from "@/views/interactiveMarketing/cardManage/components/previewCard4.vue";
import { getSkuList } from "@/api/member/pointsManagement.js";
import informationForm from "./components/informationForm.vue"
import selectPeople from "@/components/select-people-yunqi.vue";
import selectGoods from "@/components/selectGoodsMonitor2";
import draggable from "vuedraggable";
import {
  uploadImage,
  addImage,
  getList,
  delImage,
} from "@/api/jhk/sellerImageController.js";
import { measureUnitPage } from "@/api/measuringUnit";

export default {
  components: {
    selectActivityDialog,
    previewCard1,
    previewCard2,
    previewCard3,
    previewCard4,
    informationForm,
    selectPeople,
    selectGoods,
    draggable,
    gifBagStyle
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
    activityDataInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    // 活动标题
    activityTitle() {
      if (this.activityData && this.activityData.id) {
        switch (this.activityData.id) {
          case 74:
            return "关注礼包";
          case 75:
            return "加购礼包";
          default:
            return "关注礼包";
        }
      }
      return "关注礼包";
    },
    pickerOptionsValue1() {
      const that = this;
      return {
        disabledDate: (time) => {
          if (that.activityTimeValue[1]) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(
                  this.$store.getters.loginUserInfo.expiresIn
                ).valueOf() ||
              time.getTime() > new Date(that.activityTimeValue[1]).getTime()
            );
          } else {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf()
            );
          }
        },
      };
    },
    pickerOptionsValue2() {
      const that = this;
      return {
        disabledDate: (time) => {
          if (that.activityTimeValue[0]) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(
                  this.$store.getters.loginUserInfo.expiresIn
                ).valueOf() ||
              time.getTime() < new Date(that.activityTimeValue[0]).getTime()
            );
          } else {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf()
            );
          }
        },
      };
    },
    timeDay() {
      if (!this.activityTimeValue[0] || !this.activityTimeValue[1]) {
        return 0;
      }
      const startTime = new Date(this.activityTimeValue[0]);
      const endTime = new Date(this.activityTimeValue[1]);
      return Math.floor(Math.abs(endTime - startTime) / (1000 * 60 * 60 * 24));
    },
    timeOut() {
      if (!this.activityTimeValue[0] || !this.activityTimeValue[1]) {
        return 0;
      }
      const startTime = new Date(this.activityTimeValue[0]);
      const endTime = new Date(this.activityTimeValue[1]);
      const timeDiff = endTime.getTime() - startTime.getTime();
      const remainHours = timeDiff % (24 * 3600 * 1000);
      return Math.floor(remainHours / (3600 * 1000));
    },
    activityType() {
      return this.$route.query.valueRow
        ? parseInt(this.$route.query.valueRow)
        : null;
    },
    // 返回当前选中卡面的预览图片
    previewImageSrc() {
      // 获取当前激活的卡面
      const currentCardFace = this.cardFaces.find(
        (face) => face.id === this.activeCardTab
      );
      
      // 如果卡面存在且有图片URL，则返回该图片
      if (currentCardFace && currentCardFace.imageUrl) {
        return currentCardFace.imageUrl;
      }
      
      // 否则返回默认图片
      // const imageName =
      //   this.activityDataID == 57 ? "bigPart.png" : "smallPart.png";
      // return require(`@/assets/images/${imageName}`);
    },
    unitName() {
      if (this.unitList.length > 0) {
        const item = this.unitList.find((v) => v.id == this.measureUnitId);
        if (item) {
          return item.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      // 是否为自营店铺 true: 自营店铺 false: pop店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  watch: {
    cardFaces: {
      handler(newVal, oldVal) {
        console.log("🚀 ~ newVal:", newVal)
        // 深度监听
      },
      deep: true
    },
    activityData: {
      handler(newVal) {
        if (newVal && newVal.hasOwnProperty('isCopy')) {
          this.isCopy = newVal.isCopy;
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      isKeyActivity: 0,
      // 活动投放位置
      placementPosition: [],
      // 是否重点活动
      sendCount:"",
      skuList:[],
      itemListFor: [], // 商品弹框选择商品数据
      isShowGoods:false,
      isDragging: false,
      sex_all:[
           {
              value: '1',
              label: '1'
            },
            {
              value: '2',
              label: '2'
            },
            {
               value: '3',
               label: '3'
            },
      ],
      xcxUrl: '',
      selectPeopleShow: false, // 控制人群选择弹窗显示
      templateTabs: [],
      peopleList: [],
      // 人群选择相关数据
      personLab: { customizeList: [], recommendList: [] },
      disableVF: true,
      disableCUS: true,
      verCheckAll: false,
      starCheckAll: false,
      openClick: 0,
      // 模板相关数据
      templateList: [],
      templateCache: new Map(),
      selectedTemplateId: null, // 当前选中的模板ID
      // 卡面相关数据
      cardFaces: [
        {
          id: "card_0",
          title: "",
          topic: "",
          description: "",
          isShowParticipateNum: 1, // 是否展示参与人数 0-否 1-是
          isShowActivityItem: 0, // 是否展示活动商品 0-否 1-是
          templateType: 0, // 0: 系统模板, 1: 自定义模板
          cusTemplateJSON: "", // 自定义模板
          templateId: "", // 模板ID
          imageUrl: "", // 模板图片
          activeTabIndex: 0,
          activeTabId: "",
          activityInfo: {}, // 关联的活动信息
          previewData: {}, // 预览数据
          ruleForm: {
              skuList: [], // 商品列表
              actMember: "1", // 活动对象类型
        // 设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        isOpenShoppingConditions:false,
        cartFullDays:1,
        sendCount: '', // 发送人数
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0 // 参与方式
        }
      },
        },
        {
          id: "card_1",
          title: "兜底页",
          topic: "",
          description: "",
          isShowParticipateNum: 1,
          isShowActivityItem: 0,
          templateType: 0,
          cusTemplateJSON: "",
          templateId: "",
          imageUrl: "",
          activeTabIndex: 0,
          activeTabId: "",
          activityInfo: {},
          previewData: {},
          jumpUrl: "", // 跳转链接作为顶层属性
            ruleForm: {
        //设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0 // 参与方式
        }
        }
       },
      ], // 卡面列表
      acrdIndex: 0,
      activeCardTab: "card_0", // 当前激活的卡面tab
      activityDataID: 56,
      customFile: {},
      customTemplateList: [],
      params: {
        prizes: []
      },
      valueRow: "",
      backgroundOpacity: false,
      showSelectActivity: false,
      isSave: true,
      isCopy: true,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      cardIdCounter: 2,
      activityTimeValue: this.$getDate(30, 10),
      fromLoading: false, // 数据加载 显示
      joinBlackList: false,
      checked: false,
      isDraft: false,
      isBanShowGoods: false, // 是否禁止活动商品展示
      // informationForm组件所需参数
      activityStartTime: null, // 活动开始时间
      activityEndTime: null, // 活动结束时间
      peopleSelected: [], // 已选择的人群
      localStepNum: 0, // 当前步骤数
      // timeDay: 0,
      // timeOut: 0,
      ruleForm: {
        //设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        skuList: [], // 商品列表
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        jumpUrl: "",
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        modelIds: '', // 人群选择的单选值
        vermicelliVal: [], // 未关注店铺用户人群标签多选值
        starVal: [], // 店铺会员人群标签多选值
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0, // 参与方式
          isOutClose: false, // 勾选奖品发完自动结束活动
        }
      },
      uploadSize: false, // 添加上传尺寸校验标识
      defaultTemplateImage:
        "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 默认模板图片
      activityMap: {
        16: "下单有礼",
        17: "首单专享礼",
        18: "复购有礼",
        36: "打榜有礼",
        46: "满额有礼",
      },
      unitList: [], // 计量单位列表-满额
      measureUnitId: "", // 单位id-满额
      // 新增投放人群条件相关变量
      autoEndActivity: false, // 勾选奖品发放完毕自动结束活动
      deliveryCrowdType: 1, // 投放人群类型：1-关联活动，2-自定义人群
      activityData: {}, // 活动数据对象
      activeValue: 0, // 活动值
      isShopConditionExpandedOne:false,
      // 奖品设置相关变量
      sceneList: [
        {
          jfcheck: false,
          jfprice: '',
          jfshow: true,
          jdcheck: false,
          jdprice: '',
          jdshow: true,
          dqcheck: false,
          dqprice: '',
          dqquota: '',
          dqday: '',
          dqkey: '',
          dqshow: true,
          jqcheck: false,
          jqprice: '',
          jqquota: '',
          jqday: '',
          jqkey: '',
          jqshow: true,
          sendCount: 0
        }
      ],
      giftPrizeType: [], // 礼包样式数量
      libaoList: [
        {
          name: "店铺积分",
          priceName: "每份店铺积分：1",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6828.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu12.svg",
          singleAmount: "1",
          prizeType: "6", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: true,
          totalAmount: "1", //总共奖品数量
          giftFalse: true,
        },
        {
          name: "京豆",
          priceName: "每份京豆额：0",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6829.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu13.svg",
          singleAmount: "", //单份奖励数量 例如一次发放10个京豆就传10，一次发放一个6.66元的红包就传1
          prizeType: "4", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: true,
        },
        {
          name: "东券",
          priceName: "0元优惠券",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6826.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu14.svg",
          singleAmount: "1",
          prizeType: "1", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: true,
        },
        {
          name: "京券",
          priceName: "0元优惠券",
          logoImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu6827.svg",
          hoverImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zu15.svg",
          singleAmount: "1",
          prizeType: "0", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: true,
        },
      ],
      currtIndex: -3,
      libaoItem: {}, // 选中的item
      dialogPrize: false, // 弹窗
      JingdouCount: {}, // 京豆数量
      jingdouAccountNum: 0, // 京豆账户余额
      // venderType: false, // 是否为自营商家
      isStart: false // 是否已开始
    }
  },
  async created() {
    // 根据礼包类型设置埋点参数
    let giftName = "BI店铺礼包";
    if (this.activityData.id === 74) {
      giftName = "关注礼包";
    } else if (this.activityData.id === 75) {
      giftName = "加购礼包";
    }
    this.buriedPoint(1, giftName, "互动管理", "互动活动");
    // 先从路由参数获取数据并设置到activityData
    // if (this.$route.query.valueRow) {
    //   this.activityData = {
    //     id: Number(this.$route.query.valueRow) || 0,
    //     isCopy: Number(this.$route.query.isCopy) || 0
    //   };
    //   this.activeValue = Number(this.$route.query.activeValue) || 0;
    // }
    // console.log('当前玩法id---->', this.activityData.isCopy);
    // console.log('当前玩法id---->', this.activityData.id, this.activeValue,this.valueRow);
    this.loadCustomTemplate(); // 加载自定义模板
   console.log(this.activityData.id,'55555555',this.valueRow);
   
    // 无论是否有valueRow，都需要初始化模板数据
    await this.initTemplateData();
    
    if (this.valueRow && (this.activityData.id === 74 || this.activityData.id === 75)) {
      console.log(14414444);
      // this.activityDataID = 57;
      await this.getEdit();
  
      // 设置默认模板（只需要调用一次）
      // await this.setDefaultTemplateForNewActivity();
      // this.ruleForm.defaultCardUrl =
      //   "https://cdn-image.yucrm.cn//hd/images/13315956_8656e64b784e4870a7d799e4d15cfaf5.png";
      // this.defaultTemplateImage =
      //   "https://cdn-image.yucrm.cn//hd/images/13315956_8656e64b784e4870a7d799e4d15cfaf5.png";
    } else {
      // 非BI店铺礼包活动类型的初始化
      await this.setDefaultTemplateForNewActivity();
    }
   

    // // // 数据初始化
    // console.log("--- ~ this.$route.query:---", this.$route.query,this.isCopy);
    // if (this.$route.query.valueRow) {
    //   // 刷新的时候 false会从布尔值变成字符串 "false"
    //   this.backgroundOpacity =
    //     this.$route.query.backgroundOpacity === true ||
    //     this.$route.query.backgroundOpacity === "true";
    //   this.isSave =
    //     this.$route.query.isSave === true ||
    //     this.$route.query.isSave === "true";
    //   this.statusComment =
    //     this.$route.query.statusComment === true ||
    //     this.$route.query.statusComment === "true";
    //   this.isCopy = Number(this.$route.query.isCopy) || 0;
    //   this.activeValue = Number(this.$route.query.activeValue) || 0;
    //   this.type = Number(this.$route.query.type) || 0;
    //   this.valueRow = this.$route.query.valueRow;
    //   this.getEdit();
    // } else {
    //   await this.initTemplateData();
    //   await this.setDefaultTemplateForNewActivity();
    //   return; // 新建活动时直接返回，避免重复调用 initTemplateData
    // }
    // await this.initTemplateData();
  },
  mounted() {
    this.getmeasureUnitPage();
    this.getPersonLabelList();
  },
  methods: {
    // 获取人群列表
    async getPersonLabelList() {
      try {
        const { data: res } = await getPersonLabelList();
        this.personLab.customizeList = res.slice(0, 2);
        this.personLab.recommendList = res.slice(2, res.length);
        if (res.length > 0) {
          this.ruleForm.modelIds = res[0].labelId;
        }
      } catch (error) {
        console.error("获取人群列表失败:", error);
      }
    },
    isChange(){
      //  if (this.skuList.length >= 10) {
      //    this.$message.warning("加购商品最多只能选择10个");
      //    return;
      //  }
       this.isShowGoods = true
       //如果有sku的话回显
       if(this.cardFaces[this.acrdIndex].ruleForm.skuList){
          this.skuList = this.cardFaces[this.acrdIndex].ruleForm.skuList
       }
    },
    selectGoodsChange(data){
          // 只有当data不为空时才更新商品列表，点击关闭或取消时不清空
          if (data && Array.isArray(data)) {
            this.skuList = [...data];
            const currentCard = this.cardFaces[this.acrdIndex];
            if (currentCard) {
              // 确保ruleForm和ruleDTO对象存在
              if (!currentCard.ruleForm) {
                currentCard.ruleForm = {};
              }
              if (!currentCard.ruleForm.ruleDTO) {
                currentCard.ruleForm.ruleDTO = {};
              }
              // 更新当前卡面的skuList，确保是数组
              currentCard.ruleForm.skuList = [...data];
            }
            
            // 更新itemListFor，用于setParams方法
            this.itemListFor = [];
            data.forEach((value, index) => {
              let formValue = {};
              formValue.skuId = data[index].skuId;
              formValue.logo = data[index].logo;
              formValue.price = data[index].jdPrice || data[index].price;
              formValue.title = data[index].skuName || data[index].title;
              this.itemListFor.push(formValue);
            });
          }
          this.isShowGoods = false            
    },
    // 删除商品
    delec(index) {
      this.skuList.splice(index, 1);
      const currentCard = this.cardFaces[this.acrdIndex];
      if (currentCard && currentCard.ruleForm) {
        currentCard.ruleForm.skuList.splice(index, 1);
      }
      
      // 同步更新itemListFor
      if (this.itemListFor.length > index) {
        this.itemListFor.splice(index, 1);
      }
    },
    // 拖动排序结束
    onEnd() {
      this.isDragging = false;
      const currentCard = this.cardFaces[this.acrdIndex];
      if (currentCard && currentCard.ruleForm) {
        currentCard.ruleForm.skuList = [...this.skuList];
      }
      
      // 同步更新itemListFor的顺序
      this.itemListFor = [];
      if (Array.isArray(this.skuList)) {
        this.skuList.forEach((value, index) => {
          let formValue = {};
          formValue.skuId = this.skuList[index].skuId;
          formValue.logo = this.skuList[index].logo;
          formValue.price = this.skuList[index].jdPrice || this.skuList[index].price;
          formValue.title = this.skuList[index].skuName || this.skuList[index].title;
          this.itemListFor.push(formValue);
        });
      }
    },
    syncJumpLink(cardFace) {
       if (!cardFace.activityInfo) {
         cardFace.activityInfo = {};
       }
       cardFace.activityInfo.jumpLink = cardFace.jumpUrl;
     },
    //入会链接 - 为指定卡面设置入会链接
    setOpenUrl(cardFace) {
      // 确保cardFace对象存在
      if (!cardFace) return;
      
      try {
        // 获取商家ID
        let venderId = this.$store.getters.loginUserInfo.venderId;
        
        // 设置入会链接，只对当前点击的卡面生效
        let joinLink = `https://shopmember.m.jd.com/shopcard/?venderId=${venderId}&venderType=1&channel=80355979`;
        
        // 确保activityInfo对象存在
        if (!cardFace.activityInfo) {
          cardFace.activityInfo = {};
        }
        
        // 直接修改输入框绑定的属性，确保默认弹窗1也能正确赋值
        // 使用Vue.set确保响应式更新
        if (this.$set) {
          this.$set(cardFace, 'jumpUrl', joinLink);
        } else {
          // 降级方案
          cardFace.jumpUrl = joinLink;
        }
        
        // 同步更新相关属性，确保数据一致性
        cardFace.activityInfo.jumpUrl = joinLink;
        cardFace.activityInfo.jumpLink = joinLink;
        
        // 手动触发同步方法
        this.syncJumpLink(cardFace);
        
        // 强制更新DOM，确保输入框正确显示值
        this.$nextTick(() => {
          // DOM更新后的回调，确保视图更新
        });
      } catch (error) {
        console.error('设置入会链接失败:', error);
      }
     },
     selectPeopleSure(val) {
      // 获取当前激活的卡面，并将选中的人群ID存储到卡面的ruleForm.peopleSelected中
      // 查找当前激活的卡面，使用activeCardTab作为标识
      const currentCardFace = this.cardFaces.find(item => item.id === this.activeCardTab);
      if (currentCardFace && currentCardFace.ruleForm) {
        currentCardFace.ruleForm.peopleSelected = val.map(item => item.id)
      }
      this.selectPeopleShow = false
    },
    // 初始化模板数据
    async initTemplateData() {
      try {
        this.templateLoading = true;
        // 获取模板分组数据（tabs）
        // 根据活动类型设置num参数：关注礼包传4，加购礼包传5
        let num = 1;
        if (this.activityData.id === 74) {
          num = 4;
        } else if (this.activityData.id === 75) {
          num = 5;
        }
        const GiftBag = await getGiftBagList(num);
        console.log("--- ~ GiftBag:---", GiftBag);

        // 添加"全部"tab到第一位
        this.templateTabs = [
          {
            name: "全部",
            value: -1,
            id: -1,
          },
          ...GiftBag.data.map((item) => ({
            name: item.title,
            value: item.id,
            id: item.id,
          })),
        ];

        // 获取默认模板列表
        if (this.templateTabs.length > 0) {
          await this.getTemplateList(this.templateTabs[0].id); // 默认加载第一个tab的模板（全部）
        }
      } catch (error) {
        console.error("初始化模板数据失败:", error);
        this.$message.error("加载模板数据失败");
      } finally {
        this.templateLoading = false;
      }
    },

    // 获取模板列表
    // async getTemplateList(tabIndex, cardId = null) {
    async getTemplateList(id, cardId = null) {
      try {
        console.log("--- ~ this.templateCache:---", this.templateCache);
        // 检查缓存中是否已有该tab的数据
        if (this.templateCache.has(id)) {
          console.log("从缓存中获取模板数据:", id);
          this.templateList = this.templateCache.get(id);
          return;
        }

        this.templateLoading = true;
        // 根据活动类型设置giftType：关注礼包传4，加购礼包传5
        const giftType = this.activityData.id === 74 ? 4 : (this.activityData.id === 75 ? 5 : 1);
        let obj = {
          current: 1,
          size: 10000,
          giftType: giftType,
          // 初始不设置dirId，避免使用错误的this.templateTabs.id
          // source: this.activityDataID == 56 ? 7 : 8,
        };

        // 如果不是"全部"tab，设置dirId参数
        if (id !== -1) {
          obj.dirId = id;
        }

        const { data } = await getGiftBagTemplate(obj);
        const templateList = data.records || [];

        // 将数据存入缓存
        this.templateCache.set(id, templateList);
        this.templateList = templateList;

        console.log("从接口获取并缓存模板数据:", id, templateList);
      } catch (error) {
        console.error("获取模板列表失败:", error);
        this.$message.error("获取模板列表失败");
      } finally {
        this.templateLoading = false;
      }
    },
    
    // 添加卡面
    addCardFace() {
      // 兜底页不计入添加数量，所以实际可添加数量是20-1=19
      if (this.cardFaces.length>= 20) {
        this.$message.warning("最多只能添加20个弹窗");
        return;
      }

      const newCardFace = {
        id: `card_${this.cardIdCounter++}`,
        title: "",
        topic: "",
        description: "",
        isShowParticipateNum: 1,
        isShowActivityItem: 0,
        templateType: 0,
        templateId: "",
        imageUrl: "", // 模板图片
        activeTabIndex: 0,
        activityInfo: {},
        activeTabId:
        this.templateTabs.length > 0 ? this.templateTabs[0].id : "",
        previewData: {},
        jumpUrl: "", // 跳转链接作为顶层属性
        ruleForm: {
        skuList:[],
        actMember:"1",
        modelIds: null, // 人群模型ID
        vermicelliVal: [], // 粉丝等级值
        starVal: [], // 会员等级值
        //设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        isOpenShoppingConditions:false,
        cartFullDays:1,
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0 // 参与方式
        }
      },
      };

      // 将新卡面添加到数组末尾（兜底页之前）
      // 兜底页是最后一个元素，所以在倒数第二个位置插入
      this.cardFaces.splice(this.cardFaces.length - 1, 0, newCardFace);
      // 设置新添加的卡面为激活状态
      this.activeCardTab = newCardFace.id;
      // 同步更新acrdIndex为新卡面的索引
      this.acrdIndex = this.cardFaces.length - 2;
      
      // 移除重置操作，避免覆盖新卡面数据
      
      if (this.templateTabs.length > 0) {
        const firstTabId = this.templateTabs[0].id;
        this.getGiftBagTemplate(firstTabId).then(() => {
          // 模板加载完成后，如果有模板则选中第一个
          if (this.templateList.length > 0) {
            // 获取新添加卡面的索引（在兜底页之前）
            const newCardIndex = this.cardFaces.length - 2;
            this.$set(this.cardFaces[newCardIndex], "templateId", this.templateList[0].id);
            this.$set(this.cardFaces[newCardIndex], "imageUrl", this.templateList[0].templateUrl);
            
            // 设置当前选中的模板ID
            this.selectedTemplateId = this.templateList[0].id;
            // 设置为系统模板类型
            this.$set(this.cardFaces[newCardIndex], "templateType", 0);
          }
        });
      }
    },
    
    // 重置用户条件参数
    // resetUserConditionParams() {
    //   // 重置投放人群类型
    //   // this.deliveryCrowdType = 1; // 默认1: 全部人群
    //   // 重置活动对象
    //   this.actMember = "1"; // 默认1: 全部身份
      
    //   // 重置规则表单中的用户条件参数
    //   // 新老客户类型
    //   this.ruleForm.ruleDTO.cusType = 0;
    //   // Plus会员身份
    //   this.ruleForm.ruleDTO.plusObject = 0;
    //   // 首次入会时间相关参数
    //   this.ruleForm.firstOpenCardTimeType = 0;
    //   this.ruleForm.openCardBeforeDay = "";
    //   // 开卡时间指定时间段参数
    //   this.ruleForm.ruleDTO.openCardStartTime = '';
    //   this.ruleForm.ruleDTO.openCardEndTime = '';
    //   // 是否检查开卡时间
    //   this.ruleForm.ruleDTO.isCheckOpenCardTime = false;
    //   // 购物条件 - 累计完成订单笔数
    //   this.ruleForm.orderCompleteLimitCount = '';
    //   this.ruleForm.orderCompleteMaxCount = '';
    //   // 购物条件 - 累计完成订单金额
    //   this.ruleForm.orderCompleteLimitPayment = '';
    //   this.ruleForm.orderCompleteMaxPayment = '';
    //   // 购物条件 - 最后一次订单完成时间
    //   this.ruleForm.lastOrderCompleteTimeType = 0;
    //   this.ruleForm.lastOrderCompleteStartDay = '';
    //   this.ruleForm.lastOrderCompleteEndDay = '';
    //   this.ruleForm.lastOrderCompleteStartTime = '';
    //   this.ruleForm.lastOrderCompleteEndTime = '';
    // },

    // 删除卡面
    removeCardFace(cardId) {
      if (this.backgroundOpacity) {
        return;
      }
      // 根据cardId找到对应的数组索引
      const index = this.cardFaces.findIndex((face) => face.id === cardId);
      // 不允许删除最后一个卡面（兜底页）
      if (index === this.cardFaces.length - 1) {
        this.$message.warning("默认兜底页不允许删除！");
        return;
      }
      // 确保删除后至少保留一个卡面和兜底页
      if (this.cardFaces.length <= 1) {
        this.$message.warning("请至少保留一个卡面和兜底页！");
        return;
      }
      if (index > -1) {
        this.cardFaces.splice(index, 1);
        // 如果删除的是当前激活的tab，切换到合适的tab
        if (this.activeCardTab == cardId && this.cardFaces.length > 0) {
          // 优先切换到兜底页
          const lastIndex = this.cardFaces.length - 1;
          this.activeCardTab = this.cardFaces[lastIndex].id;
        }
      }
    },

    // 选择活动
    selectActivity(index) {
      this.acrdIndex = index;
      this.showSelectActivity = true;
    },

    // 处理卡面切换事件
    async handleCardTabClick(tab) {
      console.log("切换到卡面:", tab.name, "ID:", tab.name);
      
      // 先保存当前卡面的ruleForm数据（如果存在）
      // if (this.activeCardTab && this.activeCardTab !== tab.name) {
      //   const previousCardFace = this.cardFaces.find(
      //     (face) => face.id === this.activeCardTab
      //   );
      //   if (previousCardFace && previousCardFace.ruleForm) {
      //     // 保存当前的用户条件参数到之前的卡面
      //     previousCardFace.ruleForm.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
      //     previousCardFace.ruleForm.openCardBeforeDay = this.ruleForm.openCardBeforeDay;
      //     previousCardFace.ruleForm.orderCompleteLimitCount = this.ruleForm.orderCompleteLimitCount;
      //     previousCardFace.ruleForm.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      //     previousCardFace.ruleForm.orderCompleteLimitPayment = this.ruleForm.orderCompleteLimitPayment;
      //     previousCardFace.ruleForm.orderCompleteMaxPayment = this.ruleForm.orderCompleteMaxPayment;
      //     previousCardFace.ruleForm.lastOrderCompleteTimeType = this.ruleForm.lastOrderCompleteTimeType;
      //     previousCardFace.ruleForm.lastOrderCompleteStartDay = this.ruleForm.lastOrderCompleteStartDay;
      //     previousCardFace.ruleForm.lastOrderCompleteEndDay = this.ruleForm.lastOrderCompleteEndDay;
      //     previousCardFace.ruleForm.lastOrderCompleteStartTime = this.ruleForm.lastOrderCompleteStartTime;
      //     previousCardFace.ruleForm.lastOrderCompleteEndTime = this.ruleForm.lastOrderCompleteEndTime;
          
      //     // 保存ruleDTO中的参数
      //     if (previousCardFace.ruleForm.ruleDTO && this.ruleForm.ruleDTO) {
      //       previousCardFace.ruleForm.ruleDTO.cusType = this.ruleForm.ruleDTO.cusType;
      //       previousCardFace.ruleForm.ruleDTO.plusObject = this.ruleForm.ruleDTO.plusObject;
      //       previousCardFace.ruleForm.ruleDTO.openCardStartTime = this.ruleForm.ruleDTO.openCardStartTime;
      //       previousCardFace.ruleForm.ruleDTO.openCardEndTime = this.ruleForm.ruleDTO.openCardEndTime;
      //       previousCardFace.ruleForm.ruleDTO.isCheckOpenCardTime = this.ruleForm.ruleDTO.isCheckOpenCardTime;
      //     }
      //   }
      // }
      
      // 找到当前激活的卡面
      const currentCardFace = this.cardFaces.find(
        (face) => face.id === tab.name
      );
      this.acrdIndex = this.cardFaces.indexOf(currentCardFace);
      
      // 移除重置操作，避免覆盖卡面数据
      // 从新卡面加载ruleForm数据（如果存在）
      if (currentCardFace && currentCardFace.ruleForm) {
        // 加载用户条件参数
        this.ruleForm.firstOpenCardTimeType = currentCardFace.ruleForm.firstOpenCardTimeType || 0;
        this.ruleForm.openCardBeforeDay = currentCardFace.ruleForm.openCardBeforeDay || "";
        this.ruleForm.orderCompleteLimitCount = currentCardFace.ruleForm.orderCompleteLimitCount || "";
        this.ruleForm.orderCompleteMaxCount = currentCardFace.ruleForm.orderCompleteMaxCount || "";
        this.ruleForm.orderCompleteLimitPayment = currentCardFace.ruleForm.orderCompleteLimitPayment || "";
        this.ruleForm.orderCompleteMaxPayment = currentCardFace.ruleForm.orderCompleteMaxPayment || "";
        this.ruleForm.lastOrderCompleteTimeType = currentCardFace.ruleForm.lastOrderCompleteTimeType || 0;
        this.ruleForm.lastOrderCompleteStartDay = currentCardFace.ruleForm.lastOrderCompleteStartDay || "";
        this.ruleForm.lastOrderCompleteEndDay = currentCardFace.ruleForm.lastOrderCompleteEndDay || "";
        this.ruleForm.lastOrderCompleteStartTime = currentCardFace.ruleForm.lastOrderCompleteStartTime || "";
        this.ruleForm.lastOrderCompleteEndTime = currentCardFace.ruleForm.lastOrderCompleteEndTime || "";
        // 加载partner属性，用于allowLevel回显
        this.ruleForm.partner = Array.isArray(currentCardFace.ruleForm.partner) ? [...currentCardFace.ruleForm.partner] : ["-1"];
        
        this.ruleForm.skuList = currentCardFace.ruleForm.skuList || [];
        console.log(this.ruleForm.skuList,'656565456564');
        
        



        
        // 加载关联人群参数，确保回显选中的人群
        // 加载actMember，确保回显活动对象类型
        this.actMember = currentCardFace.ruleForm.actMember || "1";
        if (Array.isArray(currentCardFace.ruleForm.peopleSelected)) {
          this.peopleList = currentCardFace.ruleForm.peopleSelected.map(id => ({ id }));
        } else {
          this.peopleList = [];
        }
        
        // 加载ruleDTO中的参数
        if (currentCardFace.ruleForm.ruleDTO && this.ruleForm.ruleDTO) {
          this.ruleForm.ruleDTO.cusType = currentCardFace.ruleForm.ruleDTO.cusType || 0;
          this.ruleForm.ruleDTO.plusObject = currentCardFace.ruleForm.ruleDTO.plusObject || 0;
          this.ruleForm.ruleDTO.openCardStartTime = currentCardFace.ruleForm.ruleDTO.openCardStartTime || "";
          this.ruleForm.ruleDTO.openCardEndTime = currentCardFace.ruleForm.ruleDTO.openCardEndTime || "";
          this.ruleForm.ruleDTO.isCheckOpenCardTime = currentCardFace.ruleForm.ruleDTO.isCheckOpenCardTime || false;
        }
      }
      if (currentCardFace && currentCardFace.activeTabId) {
        // 加载该卡面激活tab对应的模板列表
        await this.getTemplateList(currentCardFace.activeTabId);
        console.log(
          "已加载卡面模板列表，activeTabId:",
          currentCardFace.activeTabId
        );
      }
      // 修改活动的时候
      if (
        this.$route.query.valueRow &&
        this.cardFaces[this.acrdIndex].activityInfo.activityId
      ) {
        let row = {
          title: this.cardFaces[this.acrdIndex].title,
          topic: this.cardFaces[this.acrdIndex].topic,
          subType: 36,
          id: this.cardFaces[this.acrdIndex].activityInfo.activityId,
          ...this.cardFaces[this.acrdIndex].activityInfo,
        };
        console.log("--555- ~ row:---", row);
        this.handlerSelectActivity(row, true, "clickTab");
      }
    },

    // 处理tab点击事件
    async handleTabClick(id, tabIndex) {
      console.log("--- ~ id, tabIndex:---", id, tabIndex);
      const cardFace = this.cardFaces[tabIndex];
      console.log("--- ~ cardFace:---", cardFace);
      if (cardFace) {
        cardFace.activeTabId = id;
        const selectedTab = this.templateTabs.find((tab) => tab.id == id);
        console.log("选中的tab:", selectedTab, "for card index:");
        // 调用优化后的getTemplateList，会自动使用缓存
        await this.getTemplateList(id, tabIndex);
      }
    },
    // 选择模板
    selectTemplate(cardIndex, templateIndex, templateId, templateData) {
      const cardFace = this.cardFaces[cardIndex];
      if (cardFace) {
        cardFace.templateId = templateId;
        cardFace.cusTemplateJSON = "";
        // 使用templateUrl字段，因为接口已更新
        cardFace.imageUrl = templateData.templateUrl;
        console.log("选中模板:", templateData, "for card index:", cardIndex);
      }
    },

    // 选择自定义模板
    selectCustomTemplate(cardIndex, templateIndex, templateData) {
      const cardFace = this.cardFaces[cardIndex];
      if (cardFace) {
        // 使用imageUrl字段，与模板选择判断逻辑保持一致
        this.$set(cardFace, "cusTemplateJSON", templateData.imageUrl);
        this.$set(cardFace, "templateId", ""); // 清空系统模板ID
        this.$set(cardFace, "imageUrl", templateData.imageUrl);
        // 设置模板类型为自定义模板
        this.$set(cardFace, "templateType", 1);
        
        // 确保popupTemplate对象完整，用于回显
        this.$set(cardFace, "popupTemplate", {
          ...cardFace.popupTemplate,
          templateType: 1,
          templateCategory: -1,
          templateUrl: templateData.imageUrl
        });
        
        // 设置选中状态
        this.selectedTemplateId = "";
        console.log(
          "选中自定义模板:",
          templateData,
          "for card index:",
          cardIndex
        );
        
        // 强制更新视图确保选中状态正确显示
        this.$forceUpdate();
      }
    },

    //活动时间驱动
    activityTimeChange(val) {
      if (this.backgroundOpacity) return;
      if (this.activityTimeValue[1]) {
        const invalidateDate = new Date(
          this.$store.getters.loginUserInfo.expiresIn
        ).valueOf();
        const end = new Date(this.activityTimeValue[1]).getTime();

        if (end > invalidateDate) {
          this.$message.warning("活动时间不可超过互动数据授权有效期！");
          this.activityTimeValue[1] = "";
          return;
        }
      }
    },
    // 回显
    getEdit() {
      // 添加空值检查，防止valueRow为undefined或null时调用.id属性出错
      if (!this.valueRow) {
        console.error("回显失败：缺少valueRow参数");
        return;
      }
      
      giftBagEide(this.valueRow.id) // 兼容id可能直接在valueRow中的情况
        .then((res) => {
          if (res.code == 1 || res.code == 200) {
              const data = res.data;
              console.log('API返回数据:', data);
              console.log('acrdIndex:', this.acrdIndex);
              // 回显基本信息
              this.ruleForm.activityName = data.activityName || "";
              // 回显是否重点活动
              this.isKeyActivity = data.isKeyActivity || 0;
              // 回显活动投放位置
              this.placementPosition = data.placementPosition ? data.placementPosition.split(",") : ["SHOP"];
              
              // 回显活动时间
              if (data.startTime && data.endTime && !this.activityData.isCopy) {
                this.activityTimeValue = [data.startTime, data.endTime];
              } else if (!data.startTime || !data.endTime) {
                // 如果没有返回活动时间，保持为空
                this.activityTimeValue = [];
              }

              if (this.activityData.isCopy) {
                this.ruleForm.activityName += "复制";
              }

              if (this.activityData.isCopy) {
                this.activityTimeValue = [];
              }

              // 回显发送人数和自动结束活动
              if (data.ruleDto.sendCount) {
                this.sendCount = String(data.ruleDto.sendCount);
              } else {
                // 如果没有返回发送人数，保持为空
                this.sendCount = '';
              }
              if(data.ruleDto.isOutClose  == null){
                this.ruleForm.ruleDTO.isOutClose = false;
              }else{
                this.ruleForm.ruleDTO.isOutClose = data.ruleDto.isOutClose
              }
              
              // 回显其他活动条件
              this.ruleForm.jumpUrl = data.ruleDto.jumpLink || '';
              this.ruleForm.modelIds = data.ruleDto.modelIds || '';
              this.ruleForm.defaultCardUrl = data.ruleDto.defaultCardUrl || '';
              this.ruleForm.radio = data.isExposureItem || 0; // 是否添加曝光商品

              // 回显商品列表
              if (data.itemList && Array.isArray(data.itemList)) {
                this.itemListFor = [...data.itemList];
                // 回显加购商品
                if (this.activityData.id === 75) {
                  this.skuList = [...data.itemList];
                  // 同时更新当前卡面的 ruleForm.skuList，确保弹窗回显
                  const currentCard = this.cardFaces[this.acrdIndex];
                  if (currentCard) {
                    if (!currentCard.ruleForm) {
                      currentCard.ruleForm = {};
                    }
                    currentCard.ruleForm.skuList = [...data.itemList];
                  }
                }
              }


              // 投放人群
              this.deliveryCrowdType = data.ruleDto.audienceType || 1;

              // 人群处理
              if (data.ruleDto.modelIds && data.ruleDto.modelIds.indexOf(":") != -1) {
                const list = data.ruleDto.modelIds.split(":");
                const dataArr = list[1].split("_");
                this.ruleForm.modelIds = list[0];
                if (list[0] == "v1_new_p" || list[0] == "v1_plus" || list[0] == "v1_new_fans") {
                  this.ruleForm.vermicelliVal = [];
                  this.ruleForm.starVal = [];
                }
                // 粉丝
                if (list[0] == "v1_no_f") {
                  if (dataArr.length == 4) {
                    this.verCheckAll = true;
                  }
                  this.disableVF = false;
                  this.ruleForm.vermicelliVal = dataArr;
                }
                // 星极
                if (list[0] == "v1_customer") {
                  if (dataArr.length == 6) {
                    this.starCheckAll = true;
                  }
                  this.disableCUS = false;
                  this.ruleForm.starVal = dataArr;
                }
              }

              // 礼包模板设置显示奖项 1 店铺积分  2 京豆  3  京券  4  东券"
              data.giftTemplatePrizeType = data.giftTemplatePrizeType ? data.giftTemplatePrizeType : ''
              console.log('9999999', data.giftTemplatePrizeType );
              
              const numGift1 = data.giftTemplatePrizeType.indexOf("1");
              const numGift2 = data.giftTemplatePrizeType.indexOf("2");
              const numGift3 = data.giftTemplatePrizeType.indexOf("3");
              const numGift4 = data.giftTemplatePrizeType.indexOf("4");
              // 礼包样式
              if (!this.isCopy) {
                // 先将所有奖品的 giftFalse 和 backAction 设置为 false
                this.libaoList.forEach((item) => {
                  item.giftFalse = false;
                  item.backAction = false;
                });
                
                // 然后根据接口返回的 prizes 数据设置对应的奖品
                data.prizes.forEach((info) => {
                  this.libaoList.forEach((item) => {
                    if (item.prizeType == info.prizeType) {
                      item.giftFalse = true;
                      if (info.prizeType == 6) {
                        item.priceName = "每份店铺积分：" + (info.price || info.singleAmount || '');
                        item.singleAmount = info.price || info.singleAmount || '';
                        item.assetsId = info.assetsId;
                        item.backAction = true;
                      }
                      if (info.prizeType == 4) {
                        item.priceName = "每份京豆额：" + info.price;
                        item.singleAmount = info.price;
                        item.assetsId = info.assetsId;
                        item.backAction = true;
                      }
                      if (info.prizeType == 1) {
                        item.priceName = info.price + "优惠券";
                        item.singleAmount = 1;
                        item.assetsId = info.assetsId;
                        item.backAction = true;
                        if (data.isOld===0) { // 为新活动
                          item.price = info.price
                          item.quota = info.quota
                          item.singleAmount = info.singleAmount
                          item.title = info.title
                          item.totalAmount = info.totalAmount
                          item.bindType = info.bindType
                          item.skuIds = info.skuIds
                          item.validateDay = info.validateDay
                          item.giftFalse = true
                        }
                      }
                      if (info.prizeType == 0) {
                        item.priceName = info.price + "优惠券";
                        item.singleAmount = 1;
                        item.assetsId = info.assetsId;
                        item.backAction = true;
                      }
                    }
                  });
                });
                console.log("修改或查看模式");
                //曝光商品集合
                this.ruleForm.exposureSwitch = data.isExposureItem == 0 ? false : true;
                this.selectGoodsArr = data.itemList;
                this.mainImagelist = data.itemList;
                this.ruleForm.radio = data.isExposureItem;
                this.itemListFor = data.itemList;
              }
              this.ruleForm.prizes = data.prizes;
              this.templateUrlimg = data.giftTemplateUrl;
              // 优先检查是否有系统模板ID
              if (data.giftTemplateId) {
                // 如果有系统模板ID，设置为系统模板
                this.cardFaces[0].templateId = data.giftTemplateId;
                this.cardFaces[0].templateType = 0; // 设置为系统模板类型
                this.cardFaces[0].cusTemplateJSON = ""; // 清空自定义模板
                // 回显模板图片
                if (data.giftTemplateUrl) {
                  this.cardFaces[0].imageUrl = data.giftTemplateUrl;
                }
                // 同时更新acrdIndex对应的卡面
                this.cardFaces[this.acrdIndex].templateType = 0;
                this.cardFaces[this.acrdIndex].templateId = data.giftTemplateId;
                this.cardFaces[this.acrdIndex].cusTemplateJSON = "";
                if (data.giftTemplateUrl) {
                  this.cardFaces[this.acrdIndex].imageUrl = data.giftTemplateUrl;
                }
                console.log('设置为系统模板:', data.giftTemplateId, data.giftTemplateUrl);
              } else if (data.ruleDto.customPicUrl) {
                // 如果没有系统模板ID，但有自定义模板图片，设置为自定义模板
                this.cardFaces[0].imageUrl = data.ruleDto.customPicUrl;
                this.cardFaces[0].cusTemplateJSON = data.ruleDto.customPicUrl;
                this.cardFaces[0].templateType = 1; // 设置为自定义模板类型
                this.cardFaces[0].templateId = ""; // 清空系统模板ID
                // 同时更新acrdIndex对应的卡面
                this.cardFaces[this.acrdIndex].templateType = 1;
                this.cardFaces[this.acrdIndex].imageUrl = data.ruleDto.customPicUrl;
                this.cardFaces[this.acrdIndex].cusTemplateJSON = data.ruleDto.customPicUrl;
                this.cardFaces[this.acrdIndex].templateId = "";
                console.log('设置为自定义模板:', data.ruleDto.customPicUrl);
              }
              // 回显礼包模板奖项类型
              if (data.giftTemplatePrizeType) {
                this.ruleForm.giftTemplatePrizeType = data.giftTemplatePrizeType;
              }       
      }});
    },


    // 校验参数
    checkParams() {
      if (!this.activityTimeValue[0] || !this.activityTimeValue[1]) {
        this.$message.error("请填写活动时间");
        return false;
      }
      if (this.ruleForm.activityName) {
        if (this.ruleForm.activityName.length > 15) {
          // 字数不能大于15
          this.$message.warning("计划名称不能超过15个字");
          return false;
        }
      } else {
        this.$message.error("请填写活动名称");
        return false;
      }
      // if (!this.activityDesc) {
      //   this.$message.error("请填写活动描述");
      //   return false;
      // }
      // if (!this.activityRules) {
      //   this.$message.error("请填写活动规则");
      //   return false;
      // }
      
      // 校验模板选择
      // for (let i = 0; i < this.cardFaces.length; i++) {
      //   const cardFace = this.cardFaces[i];
      //   if (!cardFace.templateId && !cardFace.imageUrl) {
      //     this.$message.error("请选择模板");
      //     return false;
      //   }
      // }
      
      // 校验发送人数
      if (!this.sendCount || Number(this.sendCount) <= 0) {
        this.$message.error("请填写发送人数且人数必须大于0");
        return false;
      }
      
      // 校验奖品设置
      const hasValidPrize = this.libaoList.some(item => {
        // 检查是否为有效的奖品配置
        if (item.prizeType === '6') { // 店铺积分
          return item.giftFalse && item.singleAmount && Number(item.singleAmount) > 0;
        } else if (item.prizeType === '4') { // 京豆
          return item.giftFalse && item.singleAmount && Number(item.singleAmount) > 0;
        } else if (item.prizeType === '1') { // 东券
          return item.giftFalse && item.singleAmount && Number(item.singleAmount) > 0 && item.assetsId;
        } else if (item.prizeType === '0') { // 京券
          return item.giftFalse && item.singleAmount && Number(item.singleAmount) > 0 && item.assetsId;
        }
        return false;
      });
      if (!hasValidPrize) {
        this.$message.error("请至少设置一种奖品（店铺积分、京豆或东券）");
        return false;
      }

      // 校验奖品详情
      if (this.libaoList) {
        for (const item of this.libaoList) {
            console.log(item,'56486');
          if (item.prizeType == 6 && !item.singleAmount&& item.backAction) {
            this.$message.warning("请输入每人店铺积分");
            return false;
          }
          if (item.prizeType == 4 && !item.singleAmount && item.backAction) {
            this.$message.warning("请输入每人京豆数量");
            return false;
          }
          if (item.prizeType == 1 && item.bindType == 2 && !item.skuIds && item.backAction) {
            this.$message.warning("请选择商品");
            return false;
          }
 
          if (!this.venderType&&item.prizeType == 1 && !item.validateDay && item.backAction) {
            this.$message.warning("请填写券有效期");
            return false;
          }
          if (!this.venderType&&item.prizeType == 1 && !item.price && item.backAction) {
            this.$message.warning("请填写优惠金额");
            return false;
          }
          if (!this.venderType&&item.prizeType == 1 && !item.quota && item.backAction) {
            this.$message.warning("请填写使用条件");
            return false;
          }
        }
      }else{
         return  true
      }
      
      // 校验目标人群
      if (this.ruleForm.modelIds == "v1_no_f" || this.ruleForm.modelIds == "v1_customer") {
        const str1 = this.ruleForm.vermicelliVal && this.ruleForm.vermicelliVal.join("_");
        const str2 = this.ruleForm.starVal && this.ruleForm.starVal.join("_");
        if ((this.ruleForm.modelIds == "v1_no_f" && !str1) || (this.ruleForm.modelIds == "v1_customer" && !str2)) {
          this.$message.error("请选择目标人群");
          return false;
        }
      }
      
      if (this.deliveryCrowdType === 2) {
        // 检查每个非兜底页的卡面
        for (let i = 0; i < this.cardFaces.length - 1; i++) {
          const cardFace = this.cardFaces[i];

           //活动对象，如果是指定身份
          if (cardFace.ruleForm.firstOpenCardTimeType == 1) {
            // 开卡时间指定时间段
            if (!cardFace.ruleForm.openCardBeforeDay) {
              this.$message.error(`弹窗${i + 1}请填写开卡时间指定时间段`);
              return false;
            }
          }
          if (cardFace.ruleForm.firstOpenCardTimeType == 2) {
            // 开卡时间指定日期
            if (!cardFace.ruleForm.openCardStartTime) {
              this.$message.error(`弹窗${i + 1}请填写开卡时间指定日期`);
              return false;
            }
            if (!cardFace.ruleForm.openCardEndTime) {
              this.$message.error(`弹窗${i + 1}请填写开卡时间指定日期`);
              return false;
            }
          }
           
          //最后一次订单完成时间判断
          if (cardFace.ruleForm.lastOrderCompleteTimeType == 1) {
            // 最后一次订单完成时间指定时间段
            if (!cardFace.ruleForm.lastOrderCompleteStartDay) {
              this.$message.error(`弹窗${i + 1}请填写最后一次订单完成时间指定时间段`);
              return false;
            }
          }
          if (cardFace.ruleForm.lastOrderCompleteTimeType == 2) {
            // 最后一次订单完成时间指定日期
            if (!cardFace.ruleForm.lastOrderCompleteStartTime) {
              this.$message.error(`弹窗${i + 1}请填写最后一次订单完成时间指定日期`);
              return false;
            }
            if (!cardFace.ruleForm.lastOrderCompleteEndTime) {
              this.$message.error(`弹窗${i + 1}请填写最后一次订单完成时间指定日期`);
              return false;
            }
          }
          // 当活动对象为指定身份时，无需额外人群校验
          if (cardFace.ruleForm && cardFace.ruleForm.actMember === "3") {
            // 检查是否已选择人群
            if (!cardFace.ruleForm.peopleSelected || cardFace.ruleForm.peopleSelected.length === 0) {
              this.$message.error(`弹窗${i + 1}请选择人群`);
              return false;
            }
          }  
          // 校验跳转链接是否已填写
          if (!cardFace.jumpUrl || cardFace.jumpUrl.trim() === '') {
            this.$message.error(`弹窗${i + 1}请填写跳转链接`);
            return false;
          }
        }
        
        // 校验兜底页的跳转链接
        const bottomCardFace = this.cardFaces[this.cardFaces.length - 1];
        if (!bottomCardFace.jumpUrl || bottomCardFace.jumpUrl.trim() === '') {
          this.$message.error('兜底弹窗请填写跳转链接');
          return false;
        }
      }
      
      // 校验自定义模板
      for (let i = 0; i < this.cardFaces.length; i++) {
        const cardFace = this.cardFaces[i];
        // 检查是否选择了自定义模板但未上传图片
        if (cardFace.templateType === 1 && (!cardFace.imageUrl || !cardFace.cusTemplateJSON)) {
          // 判断是否为兜底页
          const pageType = i === this.cardFaces.length - 1 ? '兜底弹窗' : `弹窗${i + 1}`;
          this.$message.error(`选择了自定义模板，请上传图片`);
          return false;
        }
      }
      
      return true;
    },
    // 保存前校验
    preSave() {
      if (!this.checkParams()) {
        return;
      }

      if (!this.setParams()) {
        return;
      }

      // return;
      this.joinBlackList = true;
    },
    // 设置参数
    setParams() {
      console.log(this.ruleForm,'123123123123');
            //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return false;
      }
      console.log(this.activityTimeValue,'activityTimeValue');
      //活动时间的限制 - 保存草稿时不需要验证
      if (!this.isDraft && (!this.activityTimeValue[0] || !this.activityTimeValue[1])) {
        this.$message.warning("请输入活动时间");
        return false;
      }
      // 校验模板选择 - 保存草稿时不需要验证
      if (!this.isDraft) {
        const cardFace = this.cardFaces[0];
        
        if (!cardFace.templateId && !cardFace.imageUrl) {
          this.$message.warning("请选择模板");
          return false;
        }
      }
      if(this.placementPosition.length==0) {  
        this.$message.warning("请选择活动投放位置！");
        return false;
      }

      try {
        //创建活动时传参过去 - 参照points_task_activity.vue的店铺礼包传参方式
        this.params = {
          activityName: this.ruleForm.activityName, //活动名称
          activityType: this.activityData.id, //活动类型  74: 关注礼包 75: 加购礼包
          giftTemplateId: this.cardFaces[0].templateId || '', //礼包模板id
          isExposureItem: this.activityData.id === 75 ? 1 : (this.ruleForm.radio || 0), //是否添加曝光商品 0 否 1 是，加购礼包强制传1
          ruleDTO: {
            customPicUrl: this.cardFaces[0].imageUrl || '', // 自定义模板
            requestFollow: true, // 是否需要关注店铺
            jumpLink: this.ruleForm.jumpUrl || '', // 跳转链接
            buttonText: '立即领取', // 礼包确认按钮文案
            isOutClose: this.ruleForm.ruleDTO.isOutClose, // 奖品发放完毕自动结束活动
            isHavePrizes: true, // 是否有奖品
            modelIds: this.ruleForm.modelIds || '', // 人群标识
            isMemberGiftCheck: true, // 是否会员礼包
            memberGiftJumpLink: '', // 会员礼包跳转链接
            defaultCardUrl: this.ruleForm.defaultCardUrl, // 兜底卡面
            audienceType: this.deliveryCrowdType // 投放类型
          },
          prizes: [], // 奖品列表
          itemList: this.itemListFor || [], // 曝光商品集合
          isKeyActivity: this.isKeyActivity,
          placementPosition: this.placementPosition.join(","),
        };
        
        // 只在非草稿模式或有值时添加活动时间和发送人数
        if (!this.isDraft || this.activityTimeValue[0]) {
          this.params.startTime = this.activityTimeValue[0];
          this.params.endTime = this.activityTimeValue[1];
        }
        
        if (!this.isDraft || this.sendCount) {
          this.params.ruleDTO.sendCount = this.sendCount;
        }
        
        // 处理人群参数 - 参照points_task_activity.vue的传参方式
        if (this.ruleForm.modelIds == this.personLab.customizeList[1].labelId || this.ruleForm.modelIds == this.personLab.recommendList[3].labelId) {
          const str1 = this.ruleForm.vermicelliVal.join("_");
          const str2 = this.ruleForm.starVal.join("_");
          if ((this.ruleForm.modelIds == "v1_no_f" && !str1) || (this.ruleForm.modelIds == "v1_customer" && !str2)) {
            return this.$message.warning("请选择目标人群");
          }
          if (str1) {
            this.params.ruleDTO.modelIds = `${this.ruleForm.modelIds}:${str1}`;
          }
          if (str2) {
            this.params.ruleDTO.modelIds = `${this.ruleForm.modelIds}:${str2}`;
          }
        }
        if (this.ruleForm.modelIds == "v1_new_p" || this.ruleForm.modelIds == "v1_plus" || this.ruleForm.modelIds == "v1_new_fans") {
          this.params.ruleDTO.modelIds = `${this.ruleForm.modelIds}:0`;
        }
        
        // 处理奖品设置 - 参照points_task_activity.vue的传参方式
        console.log('libaoList:', this.libaoList);
        this.params.prizes = [];
        
        // 遍历libaoList生成prizes数组
        this.libaoList.forEach((item) => {
          if (item.backAction) {
            let prize = {
              prizeType: parseInt(item.prizeType),
              singleAmount: item.singleAmount || '',
              title: item.priceName || '',
              price: item.prizeType == 1 ? (item.price || '') : (item.singleAmount || ''),
              couponType: 1,
              totalAmount: this.sendCount // 奖品发放总数量，与sendCount相同
            };
            
            // 添加额外字段
            if (item.assetsId) {
              prize.assetsId = item.assetsId;
            }
            if (item.quota) {
              prize.quota = item.quota;
            }
            if (item.validateDay) {
              prize.validateDay = item.validateDay;
            }
            if (item.batchKey) {
              prize.batchKey = item.batchKey;
            }
            if (item.bindType) {
              prize.bindType = item.bindType;
            }
            if (item.skuIds) {
              prize.skuIds = item.skuIds;
            }
            if (item.quantityTotal) {
              prize.quantityTotal = item.quantityTotal;
            }
            if (item.couponType) {
              prize.couponType = item.couponType;
            }
            
            this.params.prizes.push(prize);
            console.log('添加奖品:', prize);
          }
        });
        
        console.log('最终prizes数组:', this.params.prizes);
        
        // 当选择自定义人群且活动对象为指定身份时，添加相关参数
        //关联活动的参数设置
        this.params.ruleDTO.popupList = this.cardFaces.map(
          (item, index) => {
           console.log(item,'item');
           
            let itemObj = {
              popupType:item.popupType? item.popupType:item.title === '兜底页'?'2':'1',//正常页面和兜底页
              priority: index + 1, // 弹窗优先级
              activityId: item.activityInfo.activityId,
              sellerLinkId: item.activityInfo.sellerLinkId,
              title: item.title,
              topic: item.topic,
              templateType: item.templateType, // 0: 系统模板, 1: 自定义模板
              templateId: item.templateId, // 模板ID
              jumpLink: this.deliveryCrowdType == 1 && item.activityInfo && item.activityInfo.activityId && item.activityInfo.jumpLink ? 
                  item.activityInfo.jumpLink : (item.jumpUrl || ''), // 投放人群为关联活动时，优先使用关联活动的jumpLink
              //关联活动设置
              relatedActivity:{
                activityId: item.activityInfo.activityId,
                activityName: item.activityInfo.activityName,
                subType:item.activityInfo.subType,
                sellerLinkName:item.activityInfo.sellerLinkName,
                startTime:item.activityInfo.startTime,
                endTime:item.activityInfo.endTime,
            
              },
              //弹窗模板设置
              popupTemplate:{
                templateId: item.templateId ? item.templateId:'', // 模板ID
                templateType: item.templateType, // 0: 系统模板, 1: 自定义模板
                templateUrl: item.imageUrl, // 自定义模板
                templateCategory: item.activeTabId, // 模板分类 - 使用当前选中的tab id
              },
            };
            // 活动对象 - 从ruleForm中获取并添加空值检查
            itemObj.activityTargetType = item.ruleForm && item.ruleForm.actMember !== undefined ? item.ruleForm.actMember : ''
            
            console.log('99999',item.popupType,item.title );
            
            if (item.title == '兜底页' || item.popupType == '2') {
                // 根据投放人群类型区分处理跳转链接
                if (this.deliveryCrowdType == 1 && item.activityInfo && item.activityInfo.activityId && item.activityInfo.jumpLink) {
                    // 投放人群为关联活动时，优先使用关联活动的jumpLink
                    itemObj.jumpLink = item.activityInfo.jumpLink;
                } else {
                    // 投放人群为自定义人群时，使用cardFace的jumpUrl和全局ruleForm的jumpUrl
                    itemObj.jumpLink = item.jumpUrl || this.ruleForm.jumpUrl || '';
                }
            }
            
            // 当选择自定义人群且活动对象为指定身份时，为每个卡面添加用户条件参数
            if (this.deliveryCrowdType == 2 && item.ruleForm && item.ruleForm.actMember == "2") {
              itemObj = {
                ...itemObj,
                // 新老客户类型
                cusType: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.cusType : 0,
                // Plus会员身份
                plusObject: item.ruleForm && item.ruleForm.ruleDTO && item.ruleForm.ruleDTO.plusObject !== undefined ? item.ruleForm.ruleDTO.plusObject : 0,
                // 首次入会时间相关参数
                firstOpenCardTimeType: item.ruleForm ? item.ruleForm.firstOpenCardTimeType : 0,
                openCardBeforeDay: item.ruleForm ? item.ruleForm.openCardBeforeDay : "",
                // 开卡时间指定时间段参数
                openCardStartTime: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.openCardStartTime : '',
                openCardEndTime: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.openCardEndTime : '',
                // 是否检查开卡时间
                isCheckOpenCardTime: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.isCheckOpenCardTime : false,
                // 购物条件 - 累计完成订单笔数
                orderCompleteLimitCount: item.ruleForm ? item.ruleForm.orderCompleteLimitCount : '',
                orderCompleteMaxCount: item.ruleForm ? item.ruleForm.orderCompleteMaxCount : '',
                // 购物条件 - 累计完成订单金额
                orderCompleteLimitPayment: item.ruleForm ? item.ruleForm.orderCompleteLimitPayment : '',
                orderCompleteMaxPayment: item.ruleForm ? item.ruleForm.orderCompleteMaxPayment : '',
                // 购物条件 - 最后一次订单完成时间
                lastOrderCompleteTimeType: item.ruleForm ? item.ruleForm.lastOrderCompleteTimeType : 0,
                lastOrderCompleteStartDay: item.ruleForm ? item.ruleForm.lastOrderCompleteStartDay : '',
                lastOrderCompleteEndDay: item.ruleForm ? item.ruleForm.lastOrderCompleteEndDay : '',
                lastOrderCompleteStartTime: item.ruleForm ? item.ruleForm.lastOrderCompleteStartTime : '',
                lastOrderCompleteEndTime: item.ruleForm ? item.ruleForm.lastOrderCompleteEndTime : '',
                // 会员等级设置，确保partner存在且为数组，解决allowLevel回显问题
                allowLevel: item.ruleForm && Array.isArray(item.ruleForm.partner) && item.ruleForm.partner.length ? item.ruleForm.partner.join(",") : "", 
                // 加入购物车人群条件
                isOpenShoppingConditions: item.ruleForm ? item.ruleForm.isOpenShoppingConditions : false,
                cartFullDays: item.ruleForm ? item.ruleForm.cartFullDays : 1,
                // 商品列表
                cartGoods: item.ruleForm  && item.ruleForm.skuList && Array.isArray(item.ruleForm.skuList) ? [...item.ruleForm.skuList].map((i)=>i.skuId).join(',') : '',
              };
            }
            // 关联人群参数设置
            if (this.deliveryCrowdType == 2 && item.ruleForm && item.ruleForm.actMember == "3") {
              itemObj = {
                ...itemObj,
                // 关联人群
                // 将人群ID数组转换为逗号分隔的字符串格式
                crowdIds: item.ruleForm && item.ruleForm.peopleSelected && Array.isArray(item.ruleForm.peopleSelected) 
                  ? item.ruleForm.peopleSelected.join(',') 
                  : ''
              };
            }
            return itemObj;
          }
        );
        // 自定义人群参数设置
        // if (this.isCopy) {
        //     delete obj.id;
        //  }
        
        // 修改活动时传递id
        if (this.valueRow && this.valueRow.id) {
          // this.params.id = this.valueRow.id;
          if (this.activityData.isCopy) {
            delete this.valueRow.id
          } else {
            // this.params.pointActivityId = this.$route.query.valueRow;
            this.params.id = this.valueRow.id;
          }
        }
      } catch (error) {
        console.log("--- ~ error:---", error);
        return false;
      }

      return true;
    },
    // 保存草稿
    saveDraft() {
            if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setParams(); // 调用setParams初始化参数
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setParams(); // 调用setParams初始化参数
          this.handleDialogCloseAnoth();
        });
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        console.log('handleDialogCloseAnoth 调试信息:', {
          valueRow: this.valueRow,
          isCopy: this.isCopy,
          isDraft: this.isDraft,
          isDraftEdit: this.isDraftEdit,
          activityData: this.activityData
        });
        
        // 草稿箱保存时设置状态为5
        if(this.isDraft){
          this.params.status = 5;
        }
        // 草稿箱编辑时添加活动id
        if(this.isDraftEdit && this.valueRow && this.valueRow.id){
          this.params.id = this.valueRow.id;
        }
        
        // 编辑模式且不是草稿
        if (this.valueRow && !this.isCopy && !this.isDraft && !this.isDraftEdit) {
          console.log('进入编辑模式，调用编辑接口');
          let res;
          // 如果活动已经开始，使用updateCommon接口
          if (this.activityData.isStart) {
            let updateParams = {
              activityId: this.valueRow.id,
              ruleDescription: this.params.ruleDescription,
              isExposureItem: this.activityData.id === 75 ? 1 : this.ruleForm.radio,
              itemList: this.itemListFor,
              ruleDto: this.params.ruleDTO,
              condFollow: this.ruleForm.requestFollow ? 1 : 0,
            };
            res = await updateCommon(updateParams);
          } else {
            // 活动未开始，使用editShopGift接口
            res = await editShopGift({ ...this.params, id: this.valueRow.id });
          }
          
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message || "保存成功");
            this.$router.push({
                path: "/interactiveMarketing/activityManagement",
                query: {
                  sort: "gift"
                }
              });
            this.$emit("saveEdit");
          } else {
            this.$message.error(res.message);
          }
        } else {
          console.log('进入创建模式，调用创建接口');
          // 创建模式或草稿模式
          // 使用createShopGift接口进行保存
          createShopGift(this.params).then((res) => {
            if (res.code == 1 || res.code == 200) {
              if(this.isDraft){
                this.$message.success("保存成功！");
                this.$emit("returnBack", true);
              } else {
                this.$message.success(res.message || "创建成功");
                this.$router.push({
                    path: "/interactiveMarketing/activityManagement",
                    query: {
                      sort: "gift"
                    }
                  });
                this.$emit("saveEdit");
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
      } else {
        this.$message.info(this.isDraft ? "请先勾选明确活动规则后即可保存草稿" : "请勾选明确活动规则后即可创建");
        return;
      }
    },
    clickLocalStep() {
        this.$emit("returnBack");
        return;
    },
    handleSelectActivityClose() {
      this.showSelectActivity = false;
    },
    handlerSelectActivity(row, isCloseTip = false, type = "") {
       let venderId = this.$store.getters.loginUserInfo.venderId;
        let options = {
          activityId: row.id,
          venderId: venderId,
          activityType: row.subType,
          id: 111,
          index: 222,
          sellerLinkName: row.sellerLinkName,
          sellerLinkId: row.sellerLinkId
        };
        let pcParams = encodeURIComponent(
          Object.keys(options)
            .map((item) => `${item}=${options[item]}`)
            .join("&")
        );
      
        // 判断 同一个小部件计划中所选活动不能重复，请重新选择！
        let isExist = this.cardFaces.some((item) => {
        return item.activityInfo.activityId == row.id;
        });
        if (isExist && !isCloseTip) {
        this.$message.warning(
          "同一个BI店铺礼包中所选活动不能重复，请重新选择！"
        );
        return;
       }
      // this.cardFaces[this.acrdIndex].topic = "";
      // 将选择的活动数据设置到对应的卡面
      if (this.acrdIndex !== "" && this.cardFaces[this.acrdIndex]) {
       // 根据不同活动类型生成对应的链接
        let xcxUrl = this.$commonUrl();
        // 19：特定活动类型
        if (row.subType == 19) {
          var jumpLink = xcxUrl +
             `pages/interactPark/placeOrder/placeOrder.html%3F${pcParams}`
        } 
        // 46：购买礼品类型
        else if (row.subType == 46) {
          var jumpLink = xcxUrl +
            `pages/interactTask/purchaseGifts/purchaseGifts.html%3F${pcParams}`
        }
        // 1：签到赢好礼
        else if (row.subType == 1) {
          var jumpLink = xcxUrl +
            `pages/interactTask/signPolite/signPolite.html%3F${pcParams}`
        }
        // 3：每日抢好礼
        else if (row.subType == 3) {
          var jumpLink = xcxUrl +
            `pages/interactTask/robGoodPresent/robGoodPresent.html%3F${pcParams}`;
        }
        // 4：关注店铺有礼
        else if (row.subType == 4) {
          var jumpLink = xcxUrl +
            `pages/interactTask/attentionShop/attentionShop.html%3F${pcParams}`;
        }
        // 5：邀请开卡有礼
        else if (row.subType == 5) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
          var jumpLink = xcxUrl +
            `pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
        }
        // 6：邀请关注店铺
        else if (row.subType == 6) {
          var jumpLink = xcxUrl +
            `pages/interactTask/invite/invite.html%3F${pcParams}`;
        }
        // 7：完善信息有礼
        else if (row.subType == 7) {
          var jumpLink = xcxUrl +
            `pages/interactTask/perfect_information/perfect_information.html%3F${pcParams}`;
        }
        // 8：幸运抽奖
        else if (row.subType == 8) {
          var jumpLink = xcxUrl +
            `pages/interactPark/bigTurntable/bigTurntable.html%3F${pcParams}`
        }
        // 京获客1.2 下单复购首购
        else if (
          row.subType == 16 ||
          row.subType == 17 ||
          row.subType == 18
        ) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
          var jumpLink = xcxUrl +
            `pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
        }
        // 19：下单抽奖
        else if (row.subType == 19) {
          var jumpLink = xcxUrl +
            `pages/interactPark/placeOrder/placeOrder.html%3F${pcParams}`;
        }
        // 京获客1.3 评价有礼
        else if (row.subType == 20) {
          var jumpLink = xcxUrl +
            `pages/interactTask/evaluation_gift/evaluation_gift.html%3F${pcParams}`;
        }
        // 京获客1.3 裂变神券
        else if (row.subType == 21) {
          var jumpLink = xcxUrl +
            `pages/interactTask/groupCoupon/groupCoupon.html%3F${pcParams}`;
        }
        // 京获客1.3 红包雨
        else if (row.subType == 22) {
          var jumpLink = xcxUrl +
            `pages/interactTask/redPacketRain/redPacketRain.html%3F${pcParams}`;
        }
        // 京获客1.4 疯狂抓娃娃
        else if (row.subType == 23) {
          var jumpLink = xcxUrl +
            `pages/gameCore/catchDoll/catchDoll.html%3F${pcParams}`;
        }
        // 京获客1.4 欢乐娃娃机
        else if (row.subType == 24) {
          var jumpLink = xcxUrl +
            `pages/gameCore/seekDistinct/seekDistinct.html%3F${pcParams}`;
        }
        // 预售有礼
        else if (row.subType == 27) {
          var jumpLink = xcxUrl +
            `pages/interactTask/preGift/preGift.html%3F${pcParams}`;
        }
        // 预售抽奖
        else if (row.subType == 28) {
          var jumpLink = xcxUrl +
            `pages/interactTask/prePrize/prePrize.html%3F${pcParams}`;
        }
        // 超级裂变
        else if (row.subType == 31) {
          var jumpLink = xcxUrl +
            `pages/interactTask/superCoupon/superCoupon.html%3F${pcParams}`;
        }
        // 加购有礼
        else if (row.subType == 34) {
          var jumpLink = xcxUrl +
            `pages/interactTask/addCart/addCart.html%3F${pcParams}`;
        }
        else if (row.subType == 13) {
          var jumpLink = "http://index.yeionsms.com/yidongd/index.html";
        }
        else if (row.subType == 14) {
          var jumpLink = "http://yq-hd-rc.isvjcloud.com/shop.html";
        }
        else if (row.subType == 36) {
          var jumpLink = xcxUrl +
            `pages/interactTask/orderRisk/orderRisk.html%3F${pcParams}`;
        }
        else if (row.subType == 37) {
          // 珀莱雅的活动单独处理，后续可能所有活动统一处理
          let params1 = `activityId%3D${options.activityId}%26venderId%3D${options.venderId}%26activityType%3D${options.activityType}`;
          var jumpLink = xcxUrl +
            "pages/interactTask/sampleBuyback/sampleBuyback.html%3f" +
            params1;
        }
        // 红包
        else if (row.subType == 38) {
          var jumpLink = xcxUrl +
            `pages/integralStore/exchangeHb/exchangeHb.html%3F${pcParams}`;
        }
        // 生日有礼
        else if (row.subType == 39) {
          var jumpLink = xcxUrl +
            `pages/interactTask/birthGift/birthGift.html%3F${pcParams}`;
        }
        // 会员升级礼
        else if (row.subType == 44) {
          var jumpLink = xcxUrl +
            `pages/upgradeMember/upgradeMember.html%3F${pcParams}`;
        }
        // 晒单有礼
        else if (row.subType == 41) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
          var jumpLink = xcxUrl +
            `pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
        }
        // 积分锁权
        else if (row.subType == 45) {
          var jumpLink = xcxUrl +
            `pages/interactTask/newLockAuth/newLockAuth.html%3F${pcParams}`;
        }
        // 满额有礼
        else if (row.subType == 46) {
          var jumpLink = `${xcxUrl}pages/interactTask/purchaseGifts/purchaseGifts.html%3F${pcParams}`;
        }
        // 情书贺卡
        else if (row.subType == 50) {
          var jumpLink = `${xcxUrl}pages/loveLettersCards/loveLettersCards.html%3F${pcParams}`;
        }
        // 调查问卷
        else if (row.subType == 47) {
          var jumpLink = `${xcxUrl}pages/question/question.html%3F${pcParams}`;
        }
        // 定时开奖
        else if (row.subType == 48) {
          var jumpLink = `${xcxUrl}pages/timeOpenWin/timeOpenWin.html%3F${pcParams}`;
        }
        // 0元试用
        else if (row.subType == 51) {
          var jumpLink = `${xcxUrl}pages/onTrial/onTrial.html%3F${pcParams}`;
        }
        //试用回购礼
        else if (row.subType == 52) {
          var jumpLink = `${xcxUrl}pages_2/trialRepurchase/trialRepurchase.html%3F${pcParams}`
        }
        // 购物打卡
        else if (row.subType == 53) {
          var jumpLink = `${xcxUrl}pages/shopClock/shopClock.html%3F${pcParams}`
        }
        // 集卡有礼
        else if (row.subType == 62) {
          var jumpLink = `${xcxUrl}pages_2/collectCardsGifts/collectCardsGifts.html%3F${pcParams}`
        }
        // 默认返回值
        else {
          var jumpLink = '';
        }
     
        
      this.cardFaces[this.acrdIndex].activityInfo = {
          activityId: row.id,
          activityName: row.activityName,
          subTypeStr: row.subTypeStr,
          sellerLinkId: row.sellerLinkId,
          sellerLinkName: row.sellerLinkName,
          startTime: row.startTime,
          endTime: row.endTime,
          status: row.status,
          statusStr: row.statusStr,
          subType: row.subType,
          jumpLink: jumpLink // 添加jumpLink字段
        };
        // 强制更新视图
        this.$forceUpdate();
      }
      console.log(
        "--- ~  this.cardFaces[this.acrdIndex].activityInfo:---",
        this.cardFaces[this.acrdIndex].activityInfo
      );
      this.showSelectActivity = false;
      let Arr = [16, 17, 18];
      if (Arr.includes(row.subType)) {
        purchaseActivityDetail(row.id).then((res) => {
          console.log("--- ~ res:---", res);
          let data = res.data;
          if (res.code == 1 || res.code == 200) {
            try {
              let previewData = {
                activityType: row.subType,
                title: "",
                topic: "",
                description: "",
                logo: "",
                orderCountType: "",
                imgCount: "",
                isBanGoodsShow: false,
                statisticType: "",
                orderPaymentLimit: "",
                itemLimitCount: "",
                itemList: [],
                filterType: 0, // 指定商品 0-全部, 1-指定, 2-排除
                orderLimitCount: "",
              };
              if (type == "clickTab") {
                // 点击卡面时不改变title和topic和description
                previewData.title = this.cardFaces[this.acrdIndex].title;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
              } else {
                // 小部件标题默认拿取活动名称
                this.cardFaces[this.acrdIndex].title = data.activityName;
                previewData.title = data.activityName;
                this.cardFaces[this.acrdIndex].topic =
                  this.activityMap[row.subType];
                previewData.title = data.activityName;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                this.cardFaces[this.acrdIndex].description =
                  "数量有限，先到先得";
              }
              previewData.description =
                this.cardFaces[this.acrdIndex].description;
              previewData.isShowParticipateNum =
                this.cardFaces[this.acrdIndex].isShowParticipateNum;
              previewData.prizeSettingType = data.ruleDTO.prizeSettingType; // 奖品规则 0-统一, 1-阶梯
              previewData.filterType = data.ruleDTO.filterType; // 指定商品 0-全部, 1-指定, 2-排除
              previewData.itemList = data.ruleDTO.itemList; // 指定商品 0-全部, 1-指定, 2-排除
              if (this.cardFaces[this.acrdIndex].isShowActivityItem == 1) {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = false;
                }
              } else {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = true;
                }
              }
              if (row.subType == 17) {
                // 首购专享礼没有阶梯
                previewData.prizeSettingType = 0;
              }
              previewData.orderCountType = data.ruleDTO.orderCountType; // 累计满还是单笔满
              previewData.statisticType = 0; // 单位元
              previewData.imgCount = data.pointActivityPrizeDTOList.length;
              try {
                previewData.logo = data.pointActivityPrizeDTOList[0]
                  ? data.pointActivityPrizeDTOList[0].logo
                  : "";
              } catch (error) {
                previewData.logo = "";
              }

              previewData.prizeName = data.pointActivityPrizeDTOList[0].title;
              previewData.prizeType =
                data.pointActivityPrizeDTOList[0].prizeType;
              previewData.orderPaymentLimit = data.ruleDTO.orderStartPayment; // 订单金额
              previewData.itemLimitCount = data.ruleDTO.orderStartCount || ""; // 商品件数
              if (row.subType == 17) {
              }
              if (data.ruleDTO.prizeSettingType == 1) {
                // 阶梯
                previewData.imgCount = 1;
                previewData.orderPaymentLimit =
                  data.pointActivityPrizeDTOList[0].orderAmtLimit; // 订单金额
                previewData.itemLimitCount =
                  data.pointActivityPrizeDTOList[0].itemTotalLimit; // 商品件数
                previewData.stepList = data.pointActivityPrizeDTOList.map(
                  (item) => {
                    return {
                      orderPaymentLimit: item.orderAmtLimit,
                    };
                  }
                );
              }
              this.cardFaces[this.acrdIndex].previewData = previewData;
              
              // 将关联活动的链接设置到兜底页的跳转链接输入框
              // 尝试从活动详情中获取链接，如果没有则构造一个默认链接
              let activityUrl = data.activityUrl || `https://pro.m.jd.com/mall/active/${row.id}/index.html`;
              this.ruleForm.jumpUrl = activityUrl;
            } catch (error) {
              console.log("--- ~ error:---", error);
            }
          }
        });
        // 打榜有礼 复购
      } else if (row.subType == 36) {
        orderRankDetail(row.id).then((res) => {
          console.log("--- ~ res:---", res);
          let data = res.data;
          if (res.code == 1 || res.code == 200) {
            try {
              let previewData = {
                activityType: row.subType,
                title: "",
                topic: "",
                description: "",
                logo: "",
                orderCountType: "",
                imgCount: "",
                statisticType: "",
                orderPaymentLimit: "",
                isBanGoodsShow: false,
                rankType: "", // 名次规则 0-按排名 1-按阶梯
                itemList: [],
                itemLimitCount: "",
                filterType: 0, // 指定商品 0-全部, 1-指定, 2-排除
                orderLimitCount: "",
              };
              // 小部件标题默认拿取活动名称
              if (type == "clickTab") {
                // 点击卡面时不改变title和topic和description
                previewData.title = this.cardFaces[this.acrdIndex].title;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
              } else {
                // 小部件标题默认拿取活动名称
                this.cardFaces[this.acrdIndex].title = data.activityName;
                previewData.title = data.activityName;
                this.cardFaces[this.acrdIndex].topic =
                  this.activityMap[row.subType];
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                this.cardFaces[this.acrdIndex].description =
                  "数量有限，先到先得";
              }
              previewData.description =
                this.cardFaces[this.acrdIndex].description;
              previewData.isShowParticipateNum =
                this.cardFaces[this.acrdIndex].isShowParticipateNum;
              previewData.prizeSettingType = 1; // 奖品规则 0-统一, 1-阶梯
              previewData.filterType = data.ruleDTO.skuType; // 指定商品 0-全部, 1-指定, 2-排除
              previewData.itemList = data.ruleDTO.itemList; // 指定商品 0-全部, 1-指定, 2-排除
              previewData.orderCountType = data.ruleDTO.orderCountType; // 累计满还是单笔满
              previewData.rankType = data.ruleDTO.rankType; // 名次规则 0-排名,1-阶梯
              previewData.imgCount = 1;
              if (this.cardFaces[this.acrdIndex].isShowActivityItem == 1) {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = false;
                }
              } else {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = true;
                }
              }
              try {
                previewData.logo = data.prizeDTOList[0]
                  ? data.prizeDTOList[0].pointActivityPrizeDTOList[0].logo
                  : "";
              } catch (error) {
                previewData.logo = "";
              }
              try {
                previewData.prizeName =
                  data.prizeDTOList[0].pointActivityPrizeDTOList[0].title;
              } catch (error) {
                previewData.prizeName = data.pointActivityPrizeDTOList[0].title;
              }
              try {
                previewData.prizeType =
                  data.prizeDTOList[0].pointActivityPrizeDTOList[0].prizeType;
              } catch (error) {
                previewData.prizeType =
                  data.pointActivityPrizeDTOList[0].prizeType;
              }
              try {
                previewData.stepList = data.prizeDTOList.map((item) => {
                  return {
                    orderPaymentLimit:
                      item.pointActivityPrizeDTOList[0].totalAmount,
                  };
                });
              } catch (error) {
                previewData.stepList = data.pointActivityPrizeDTOList.map(
                  (item) => {
                    return {
                      orderPaymentLimit: item.totalAmount,
                    };
                  }
                );
              }
              if (previewData.rankType == 0) {
                previewData.imgCount =
                  data.prizeDTOList[0].pointActivityPrizeDTOList.length;
              }
              this.cardFaces[this.acrdIndex].previewData = previewData;
            } catch (error) {
              console.log("--- ~ error:---", error);
            }
          }
        });
        // 满额
      } else if (row.subType == 46) {
        fullGiftDetail(row.id).then((res) => {
          console.log("-满额详情-- ~ res:---", res);
          let data = res.data;
          if (res.code == 1 || res.code == 200) {
            // statisticType: 0满额, 1满件, 3满笔, 2满额且满件
            // orderPaymentLimit 满额
            // itemLimitCount 满件
            // orderLimitCount 满笔
            let previewData = {
              activityType: row.subType,
              title: "",
              topic: "",
              description: "",
              logo: "",
              imgCount: "",
              isBanGoodsShow: false,
              statisticType: "",
              orderPaymentLimit: "",
              orderType: "",
              itemLimitCount: "",
              itemList: [],
              orderLimitCount: "",
              measureUnitLimitCount: "", // 自定义计量单位的消费门槛
            };
            try {
              // 小部件标题默认拿取活动名称
              if (type == "clickTab") {
                // 点击卡面时不改变title和topic和description
                previewData.title = this.cardFaces[this.acrdIndex].title;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                previewData.description =
                  this.cardFaces[this.acrdIndex].description;
              } else {
                // 小部件标题默认拿取活动名称
                this.cardFaces[this.acrdIndex].title = data.activityName;
                this.cardFaces[this.acrdIndex].topic = JSON.parse(
                  data.ruleDTO.customerPaperwork
                ).title;
                previewData.title = data.activityName;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                this.cardFaces[this.acrdIndex].description =
                  JSON.parse(data.ruleDTO.customerPaperwork).desc ||
                  "数量有限，先到先得";
              }
              previewData.description =
                this.cardFaces[this.acrdIndex].description;
              previewData.isShowParticipateNum =
                this.cardFaces[this.acrdIndex].isShowParticipateNum;
              previewData.statisticType = data.ruleDTO.statisticType;
              previewData.prizeSettingType = data.ruleDTO.prizeSettingType; // 奖品规则 0-统一, 1-阶梯
              previewData.orderType = data.ruleDTO.orderType; // 0-订单付款, 1-订单完成
              previewData.orderCountType = data.ruleDTO.orderCountType; // 1累计满 2单笔满
              previewData.filterType = data.ruleDTO.filterType; // 0全部 1指定商品 2排除商品
              previewData.orderPaymentLimit = data.ruleDTO.orderPaymentLimit;
              previewData.itemLimitCount = data.ruleDTO.itemLimitCount;
              previewData.orderLimitCount = data.ruleDTO.orderLimitCount;
              previewData.imgCount = data.pointActivityPrizeDTOList.length;
              this.measureUnitId = data.ruleDTO.measureUnitId;
              previewData.measureUnitLimitCount =
                data.ruleDTO.measureUnitLimitCount;
              previewData.logo = data.pointActivityPrizeDTOList[0].logo;
              previewData.prizeName = data.pointActivityPrizeDTOList[0].title;
              previewData.prizeType =
                data.pointActivityPrizeDTOList[0].prizeType;
              this.cardFaces[this.acrdIndex].previewData = previewData;
              if (this.cardFaces[this.acrdIndex].isShowActivityItem == 1) {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = false;
                }
              } else {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = true;
                }
              }
              if (data.ruleDTO.prizeSettingType == 1) {
                this.cardFaces[this.acrdIndex].previewData.stepList =
                  data.ruleDTO.stepList;
                // 取pointActivityPrizeDTOList里面 taskIndex == 1的数据个数
                previewData.imgCount = data.pointActivityPrizeDTOList.filter(
                  (item) => item.taskIndex === 1
                ).length;
                previewData.orderPaymentLimit =
                  data.ruleDTO.stepList[0].orderPaymentLimit;
                previewData.itemLimitCount =
                  data.ruleDTO.stepList[0].itemLimitCount;
                previewData.measureUnitLimitCount =
                  data.ruleDTO.stepList[0].measureUnitLimitCount;
              }
              if (data.ruleDTO.sellerSkuList[0]) {
                let skuIdList = data.ruleDTO.sellerSkuList[0].skuIds;
                console.log("--- ~ skuIdList:---", skuIdList);
                let params = {
                  current: 1,
                  size: 5,
                  categoryId: "",
                  skuIds: "",
                  wareStatus: "",
                  wareIdStr: "",
                  venderId: 13315956,
                };
                if (skuIdList) {
                  params.skuIds = skuIdList.join(",");
                }
                getSkuList(params).then((res) => {
                  console.log("--- ~ res:---", res);
                  if (res.code == 1) {
                    previewData.itemList = res.data.records;
                    console.log(
                      "--- ~ previewData.itemList:---",
                      previewData.itemList
                    );
                  }
                });
              }
              console.log("--- ~ previewData:---", previewData);
            } catch (error) {
              console.log("--- ~ error:---", error);
            }
          }
        });
      }
    },
    updatePreviewData(index, type) {
      let previewData = this.cardFaces[index].previewData;
      previewData.title = this.cardFaces[index].title;
      previewData.topic = this.cardFaces[index].topic;
      previewData.description = this.cardFaces[index].description;
      previewData.isShowParticipateNum =
        this.cardFaces[index].isShowParticipateNum;
      if (this.cardFaces[index].isShowActivityItem == 1) {
        if (previewData.filterType == 1 || previewData.filterType == 2) {
          previewData.isBanGoodsShow = false;
        }
      } else {
        if (previewData.filterType == 1 || previewData.filterType == 2) {
          previewData.isBanGoodsShow = true;
        }
      }
    },
    onBeforeUpload(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 630;
        let height = 788;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          if (this.activityDataID == 56) {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          } else {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          }
          return Promise.reject();
        }
      );
      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".gif"];
      const isType = sorts.includes(type);
      // if (!isLt1M) {
      //   this.$message.info("上传图片大小不能超过 1MB");
      // }
      if (!isType) {
        if (this.activityDataID == 56) {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        } else {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        }
      }
      // return isLt1M && isType && isSize;
      return isType && isSize;
    },
    onBeforeUpload2(file) {
      this.customFile.imageName = file.name;
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 630;
        let height = 788;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          if (this.activityDataID == 56) {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          } else {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          }

          return Promise.reject();
        }
      );
      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".gif"];
      const isType = sorts.includes(type);
      // if (!isLt1M) {
      //   this.$message.info("上传图片大小不能超过 1MB");
      // }
      if (!isType) {
        if (this.activityDataID == 56) {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        } else {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        }
      }
      // return isLt1M && isType && isSize;
      return isType && isSize;
    },
    onUploadSuccess2(res, cardIndex) {
      if (res.code != 1) {
        this.$message.error(res.message || "上传失败");
        return;
      }
      // 更新对应卡面的自定义模板图片
      if (this.cardFaces[cardIndex]) {
        this.cardFaces[cardIndex].cusTemplateJSON = res.data;
        this.cardFaces[cardIndex].templateId = "";
        this.cardFaces[cardIndex].imageUrl = res.data;
        // 强制更新视图
        this.$forceUpdate();
      }
      // 根据活动类型设置giftType：关注礼包传4，加购礼包传5
      const giftType = this.activityData.id === 74 ? 4 : (this.activityData.id === 75 ? 5 : 1);
      const giftTypeText = this.activityData.id === 74 ? "关注礼包-" : (this.activityData.id === 75 ? "加购礼包-" : "");
      let form = {
        imageUrl: res.data,
        imageName: giftTypeText + this.customFile.imageName,
        type: 2,
        source: 9,
      };
      addImage(form).then((res) => {
        // 往图片库添加请求
        if (res && res.code == 1) {
          this.$message.success(res.message || "上传成功");
          this.loadCustomTemplate();
        }
      });
    },
    // 上传成功
    onUploadSuccess(res) {
      if (res.code != 1) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      // 更新模板图片
      this.ruleForm.defaultCardUrl = res.data;
      this.uploadSize = true;
      // 强制更新视图
      this.$forceUpdate();
      this.$message.success("上传成功");
    },

    // 重置模板图片
    onTemplateReset() {
      this.ruleForm.defaultCardUrl = this.defaultTemplateImage;
      this.uploadSize = false;
      this.$forceUpdate();
      this.$message.success("重置成功");
    },
    async setDefaultTemplateForNewActivity() {
      try {
        // 确保有模板tabs和卡面
        if (this.templateTabs.length > 0 && this.cardFaces.length > 0) {
          const firstTabId = this.templateTabs[0].id;
          
          // 设置第一个卡面为系统模板
          const firstCardFace = this.cardFaces[0];
          firstCardFace.templateType = 0;
          firstCardFace.activeTabId = firstTabId;
          
          // 设置最后一个卡面（兜底页）为系统模板
          const lastCardFace = this.cardFaces[this.cardFaces.length - 1];
          lastCardFace.templateType = 0;
          lastCardFace.activeTabId = firstTabId;
          
          // 获取第一个tab的模板列表
          await this.getTemplateList(firstTabId);
          
          // 为两个卡面都设置第一个模板
          if (this.templateList.length > 0) {
            const firstTemplate = this.templateList[0];
            // 设置第一个卡面的模板
            this.$set(firstCardFace, "templateId", firstTemplate.id);
            this.$set(firstCardFace, "imageUrl", firstTemplate.templateUrl);
            
            // 设置最后一个卡面（兜底页）的模板
            this.$set(lastCardFace, "templateId", firstTemplate.id);
            this.$set(lastCardFace, "imageUrl", firstTemplate.templateUrl);
            
            // 设置当前选中的模板ID
            this.selectedTemplateId = firstTemplate.id;
          }
          
          console.log("--- 卡面1:---", firstCardFace);
          console.log("--- 兜底页:---", lastCardFace);
        }
      } catch (error) {
        console.error("设置默认模板失败:", error);
      }
    },
    // 处理模板类型改变事件
    async handleTemplateTypeChange(value) {
      console.log("模板类型改变:", value);
      if (value == 0) {
        console.log("切换到系统模板");
        // this.cardFaces[this.acrdIndex].templateId = "";
      } else if (value == 1) {
        // this.loadCustomTemplate();
      }
    },
    //单选处理
    radioChange(val) {
        // 选中未关注店铺 启用改单选对应的多选 并禁用其他多选
      if (val == "v1_no_f") {
        this.ruleForm.starVal = [];
        this.disableVF = false;
        this.disableCUS = true;
        this.starCheckAll = false;
      } else if (val == "v1_customer") {// 选中店铺店铺会员 启用改单选对应的多选 并禁用其他多选
        this.disableCUS = false;
        this.disableVF = true;
        this.ruleForm.vermicelliVal = [];
        this.verCheckAll = false;
      } else {
        this.ruleForm.starVal = [];
        this.ruleForm.vermicelliVal = [];
        this.verCheckAll = false;
        this.starCheckAll = false;
        this.disableVF = true;
        this.disableCUS = true;
      }
    },
    handleCheckedChange(val) {
      // 处理全选变化
      if (val) {
        const foundItem = this.personLab.customizeList.find((item) => item.labelId === this.ruleForm.modelIds);
        this.ruleForm.vermicelliVal = foundItem && foundItem.labelVal ? foundItem.labelVal.map((item) => item.level) : [];
      } else {
        this.ruleForm.vermicelliVal = [];
      }
    },
    handleCheckedStarChange(val) {
      // 处理推荐人群全选变化
      if (val) {
        const foundItem = this.personLab.recommendList.find((item) => item.labelId === this.ruleForm.modelIds);
        this.ruleForm.starVal = foundItem && foundItem.labelVal ? foundItem.labelVal.map((item) => item.level) : [];
      } else {
        this.ruleForm.starVal = [];
      }
    },
    handleChang(val) {
      // 处理多选变化
      // if (this.ruleForm.vermicelliVal.length > 0) {
      //   this.verCheckAll = true;
      // } else {
      //   this.verCheckAll = false;
      // }
      // if (this.ruleForm.starVal.length > 0) {
      //   this.starCheckAll = true;
      // } else {
      //   this.starCheckAll = false;
      // }

      //    const num1 = this.personLab.customizeList[this.personLab.customizeList.length - 1].labelVal.length;
      // const num2 = this.personLab.recommendList[this.personLab.recommendList.length - 1].labelVal.length;
      // if (this.ruleForm.vermicelliVal.length == num1) {
      //   this.verCheckAll = true;
      // } else {
      //   if (this.verCheckAll) {
      //     this.verCheckAll = false;
      //   }
      // }
      // if (this.ruleForm.starVal.length == num2) {
      //   this.starCheckAll = true;
      // } else {
      //   if (this.starCheckAll) {
      //     this.starCheckAll = false;
      //   }
      // }

      const num1 = this.personLab.customizeList[this.personLab.customizeList.length - 1].labelVal.length;
      const num2 = this.personLab.recommendList[this.personLab.recommendList.length - 1].labelVal.length;
      if (this.ruleForm.vermicelliVal.length == num1) {
        this.verCheckAll = true;
      } else {
        if (this.verCheckAll) {
          this.verCheckAll = false;
        }
      }
      if (this.ruleForm.starVal.length == num2) {
        this.starCheckAll = true;
      } else {
        if (this.starCheckAll) {
          this.starCheckAll = false;
        }
      }

      if(this.ruleForm.starVal.indexOf('-1') == -1 && this.ruleForm.starVal.length != 0){
          this.openClick = 1;
      }else if(this.ruleForm.starVal.length == 0){
        this.openClick = 3 ;
      }else{
        this.openClick = 2 ;
      }
    },
    async loadCustomTemplate() {
      const { data } = await sellerImage({
        type:2,
        source: 9,
        current: 1,
        size: 10000,
      });
      // 根据活动类型过滤自定义模板
      const giftTypeText = this.activityData.id === 74 ? "关注礼包-" : (this.activityData.id === 75 ? "加购礼包-" : "");
      let filteredTemplates = data.records || [];
      if (giftTypeText) {
        // 过滤出包含当前礼包类型前缀的模板
        filteredTemplates = filteredTemplates.filter(item => {
          // 同时包含当前礼包类型前缀的模板，以及没有前缀的模板（兼容旧数据）
          return item.imageName.startsWith(giftTypeText) || !item.imageName.startsWith("关注礼包-") && !item.imageName.startsWith("加购礼包-");
        });
      }
      this.customTemplateList = filteredTemplates;
    },
    deleteCustomTemplate(id) {
      // 删除模板
      delImage(id).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.message || "删除成功");
          this.loadCustomTemplate();
        }
      });
    },
    getmeasureUnitPage() {
      let data = {
        venderId: this.venderId, // 商家ID，需要从store或其他地方获取
        size: 9999,
        current: 1,
      };
      measureUnitPage(data).then((res) => {
        if (res.code == 1) {
          const list = res.data.records || [];
          this.unitList = list.filter((v) => v.status == 1);
        }
      });
    },
    // 数字输入校验
    scenariobCheckputn(event, type) {
      let value = event.target ? event.target.value : event;
      let num = value.replace(/[^0-9]/g, '');
      if (type == '1') {
        if (parseInt(num) > 365) {
          num = 365;
        }
      } else {
        if (parseInt(num) > 999999999) {
          num = 999999999;
        }
      }
      return num;
    },
    // 处理礼包样式点击
    handleClickPoint(item, i) {
      if (this.isStart) return;
      this.currtIndex = i;
      this.libaoItem = item;
      // 设置backAction为true，确保奖品被添加到prizes数组中
      this.libaoList[i].backAction = true;
      if(item.prizeType == 1){ // 东券
        this.libaoList[i].quota = item.quota
        this.libaoList[i].price = item.price
        this.libaoList[i].validateDay = item.validateDay
        this.libaoList[i].couponType = item.couponType
        this.libaoList[i].bindType = item.bindType
        this.libaoList[i].batchKey = item.batchKey
        this.libaoList[i].skuIds = item.skuIds
        this.libaoList[i].priceName = item.title || `满${item.quota}减${item.price}优惠券`
      } else if(item.prizeType == 6){ // 店铺积分
        this.libaoList[i].singleAmount = item.singleAmount
        this.libaoList[i].priceName = `每份店铺积分：${item.singleAmount}`
      } else if(item.prizeType == 4){ // 京豆
        this.libaoList[i].singleAmount = item.singleAmount
        this.libaoList[i].priceName = `每份京豆额：${item.singleAmount}`
      }
    },
    // 移除奖品
    handleRemovePoint(item, i) {
      if (this.isStart) return;
      this.libaoList[i].backAction = false;
      this.libaoList[i].singleAmount = "";
      if (item.assetsId) {
        this.libaoList[i].assetsId = "";
      }
      if (item.prizeType == 6) {
        this.libaoList[i].priceName = "每份店铺积分：0";
      }
      if (item.prizeType == 4) {
        this.libaoList[i].priceName = "每份京豆额：0";
      }
      if (item.prizeType == 1) {
        this.libaoList[i].priceName = "0优惠券";
      }
      if (item.prizeType == 0) {
        this.libaoList[i].priceName = "0元优惠券";
      }
      let num = -1
      this.params.prizes.forEach((ele, index) => {
        if (ele.prizeType == item.prizeType) {
          num = index
        }
      })
      if (num != -1) {
        this.params.prizes.splice(num, 1);
      }
    },
    // 接收礼包样式弹窗
    closePrize(val, item) {
      this.dialogPrize = false;
      if (val) {
        // 京券
        if (item.prizeType == "0") {
          let params = {
            assetsId: item.couponId,
            price: item.discount, //满100减10   填10
            prizeType: item.prizeType,
            singleAmount: 1, // 使用条件 默认为1
            title: `${item.name}`,
            quota: item.quota, //满100减10   填100
            couponType: item.couponType
          };
          this.libaoList[this.currtIndex].priceName = item.discount + "元优惠券";
          this.libaoList[this.currtIndex].singleAmount = 1;
          this.libaoList[this.currtIndex].assetsId = item.assetsId;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.params.prizes.forEach((ele) => {
              if (ele.prizeType == "0") {
                ele.assetsId = item.couponId;
                ele.price = item.discount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = 1;
                ele.title = `${item.name}`;
                ele.quota = item.quota;
                ele.couponType = item.couponType
              }
            });
          } else {
            this.params.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "1") {
          // 东券
          let params = {
            assetsId: item.couponId,
            price: item.discount,
            prizeType: item.prizeType,
            singleAmount: 1,
            title: `${item.name}`,
            quota: item.quota,
            couponType: item.couponType
          };
          this.libaoList[this.currtIndex].priceName = item.discount + "元优惠券";
          this.libaoList[this.currtIndex].singleAmount = 1;
          this.libaoList[this.currtIndex].assetsId = item.assetsId;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.params.prizes.forEach((ele) => {
              if (ele.prizeType == "1") {
                ele.assetsId = item.couponId;
                ele.price = item.discount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = 1;
                ele.title = `${item.name}`;
                ele.quota = item.quota;
              }
            });
          } else {
            this.params.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "6") {
          // 积分
          let params = {
            price: item.point,
            prizeType: item.prizeType,
            singleAmount: item.point,
            title: `${item.point}积分`,
          };
          this.libaoList[this.currtIndex].priceName = "每份店铺积分：" + item.point;
          this.libaoList[this.currtIndex].singleAmount = item.point;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.params.prizes.forEach((ele) => {
              if (ele.prizeType == "6") {
                ele.price = item.point;
                ele.prizeType = item.prizeType;
                ele.singleAmount = item.point;
                ele.title = `${item.point}积分`;
              }
            });
          } else {
            this.params.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "4") {
          // 京豆
          let params = {
            assetsId: item.activityName.value,
            price: item.singleAmount,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount,
            title: `${item.singleAmount}京豆`,
            quantityTotal: item.quantityTotal,
          };
          this.libaoList[this.currtIndex].priceName = "每份京豆额：" + item.singleAmount;
          this.libaoList[this.currtIndex].singleAmount = item.singleAmount;
          this.libaoList[this.currtIndex].assetsId = item.activityName.value;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.params.prizes.forEach((ele) => {
              if (ele.prizeType == "4") {
                ele.assetsId = item.activityName.value;
                ele.price = item.singleAmount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = item.singleAmount;
                ele.title = `${item.singleAmount}京豆`;
                ele.quantityTotal = item.quantityTotal;
              }
            });
          } else {
            this.params.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        }
      }
    },
    // 设置东券数据
    setDonCoupon(item) {
      // 东券
      let params = {
        price: item.price,
        quota: item.quota,
        prizeType: item.prizeType,
        singleAmount: 1,
        validateDay: item.validateDay,
        title: item.title,
        bindType: item.bindType,
        skuIds: item.skuIds,
        batchKey: item.batchKey,
      };
      // 判断是否选中
      if (this.libaoItem.backAction == true) {
        this.params.prizes.forEach((ele) => {
          if (ele.prizeType == "1") {
            ele.price = item.price;
            ele.quota = item.quota;
            ele.prizeType = item.prizeType;
            ele.singleAmount = 1;
            ele.validateDay = item.validateDay;
            ele.title = item.title;
            ele.bindType = item.bindType;
            ele.skuIds = item.skuIds;
            ele.batchKey = item.batchKey;
          }
        });
      } else {
        this.params.prizes.push(params);
      }
      // 更新libaoList中的东券数据
      const couponIndex = this.libaoList.findIndex(item => item.prizeType === '1');
      if (couponIndex >= 0) {
        this.libaoList[couponIndex].backAction = true;
        this.libaoList[couponIndex].price = item.price;
        this.libaoList[couponIndex].quota = item.quota;
        this.libaoList[couponIndex].validateDay = item.validateDay;
        this.libaoList[couponIndex].bindType = item.bindType;
        this.libaoList[couponIndex].skuIds = item.skuIds;
        this.libaoList[couponIndex].batchKey = item.batchKey;
        this.libaoList[couponIndex].priceName = item.title || `满${item.quota}减${item.price}优惠券`;
      }
    },
    // 跳转到京豆充值页面
    jumpJingduo() {
      window.open('https://jshop.jd.com/account/beanRecharge', '_blank');
    },
    // 发送人数输入处理
    handleSendCount() {
      if (!this.sendCount) {
        this.$message.warning('请输入发送人数');
        return false;
      }
      if (Number(this.sendCount) < 1) {
        this.$message.warning('发送人数至少为1');
        this.sendCount = 1;
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  color: #333;
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  height: 100%;

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 40px 0 20px;
    height: calc(100% - 130px);
    overflow-y: auto;

    .lastTime {
      margin-left: 20px;
      font-size: 14px;

      i {
        color: #ccc;
      }
    }
  }
}

/* 卡面tabs样式 */
.el-tabs--card > .el-tabs__header {
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 15px;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #e4e7ed;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  margin-right: 5px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #fff;
  background-color: #fff;
}

/* 奖品设置样式 */
.shopSetLeft-connet {
  width: 740px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
  .inner {
    width: 360px;
    min-height: 214px;
    background: #ffffff;
    border: 1px solid #f5f5f5;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 10px;
    .innerTap {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0 12px;
      background: #f5f5f5;
      border-radius: 8px 8px 0px 0px;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      .logoImg {
        margin-right: 10px;
        display: inline-block;
      }
      .innerTap-name {
        display: inline-flex;
        width: 186px;
        height: 26px;
        padding-left: 19px;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }
    }
    .innerTip {
      width: 100%;
      font-size: 14px;
      color: #333333;
      padding: 20px 0 0 0;
      .innerTip-content {
        color: #333;
        display: flex;
        margin-bottom: 10px;
        padding: 0 18px;
        align-items: center;
        a {
          color: #2768FF;
        }
      }
      .innerTip-content-name {
        font-size: 14px;
        width: 120px;
      }
      .innerTip-content-input {
        width: 68%;
        display: flex;
        align-items: center;
        span {
          margin-left: 8px;
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}

.zhuyi {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
}

.notes {
  margin-top: 15px;
}
</style>

<style lang="scss" scoped>
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
}

/* 模板容器样式 */
.template-container {
  display: flex;
  flex-wrap: wrap;
  max-width: 650px;
  margin-top: 10px;
}

.template-item {
  width: 100px;
  // height: 200px;
  // overflow: hidden;
  margin-right: 15px;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;
  border-radius: 2px;

  .template-item-wrapper {
    position: relative;

    &:hover .delectIcom {
      display: block;
    }
  }

  .delectIcom {
    position: absolute;
    top: -5px;
    left: -5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    display: none;
    z-index: 10;

    &:hover {
      opacity: 0.8;
    }
  }
}

.template-image {
  width: 100%;
  height: auto;
}

.template-name {
  width: 100%;
  overflow: hidden;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  padding: 2px;
  bottom: 10px;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}

.template-selected-icon {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 15px;
    height: 15px;
  }

  /* 人群选择相关样式 */
  .crowd-container {
    margin: 20px 0;
  }


.cardSet {
  display: flex;
  gap: 20px;
  position: relative;
  padding: 20px 0;
  margin: 0 0 10px 0;
  width: 1260px;
  // // 小屏时
  // @media screen and (max-width: 1400px) {
  //   width: 85%;
  // }
  // @media screen and (max-width: 1200px) {
  //   width: 100%;
  // }

  .preview-image-wrapper {
    width: 235px;
    height: 500px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    position: absolute;
    top: 1200px;
    left: 1270px;
    background-color: #666;

    .preview-prize-list {
      position: absolute;
      bottom: 150px;
      left: 10px;
      right: 10px;
      border-radius: 4px;
      padding: 10px;
      z-index: 10;

      .preview-prize-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;

        &:last-child {
          border-bottom: none;
        }

        .prize-label {
          font-size: 12px;
          color: #333;
          font-weight: 500;
        }

        .prize-value {
          font-size: 14px;
          color: #ff6600;
          font-weight: bold;
        }
      }
    }

    .preview-image {
      // width: 100%;
      // height: 100%;
      // object-fit: cover;

    width: 90%;
    /* height: 100%; */
    -o-object-fit: cover;
    object-fit: cover;
    line-height: 100px;
    margin-top: 110px;
    margin-left: 11px;

    }
  }

  .form-content {
    flex: 1;
  }
}

.activityDetail {
  display: flex;
  flex-direction: column;
  margin-top: 8px;

  span {
    line-height: 16px;
    margin: 4px 0;
  }
}

.template-tabs {
  display: flex;
  margin-top: 10px;
}

.tab-item {
  padding: 4px 12px;
  border: 1px solid #dcdfe6;
  line-height: 16px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.3s;
  margin-left: -1px;
  position: relative;
}

.tab-item.first {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  margin-left: 0;
}

.tab-item.last {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.tab-item:hover {
  color: #3159ff;
  border-color: #3159ff;
  z-index: 1;
}

.tab-item.active {
  color: #3159ff;
  border-color: #3159ff;
  background-color: #f0f7ff;
  z-index: 2;
}

.ml10 {
  margin-left: 10px;
}

.c_666 {
  color: #666;
}

.c_999 {
  color: #999;
}

/deep/ .el-tabs__nav-prev {
  bottom: 0px !important;
}

/deep/ .el-tabs__nav-next {
  bottom: 0px !important;
}

/deep/ .el-tabs__content {
  overflow: visible;
}

.upload-template {
  margin-bottom: 12px;
  .upload-actions {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .template-preview {
    display: flex;
    align-items: flex-start;
    margin-top: 15px;

    .template-image {
      width: 160px;
      height: 76px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
      margin-right: 15px;
    }

    .image-slot {
      width: 100%;
      height: 100%;
      background: #f5f7fa;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 30px;
        color: #909399;
      }
    }

    .upload-tips {
      line-height: 1.8;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.c_999 {
  color: #999;
}


.previewTip {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  text-align: center;
}

.previewBg {
  position: absolute;
  top: 170px;
  left: 5px;
  width: 96%;
  height: 112px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}

.previewBg2 {
  position: absolute;
  top: 170px;
  left: 5px;
  height: 223px;
  width: 96%;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}
.condition-title {
  font-weight: 600;
  color: #000;
}
.toggle-btn {
  margin-left: 8px;
}
.cart-add-goods{
  margin-top: 12px;
}

/* 人群选择相关样式 */
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  
  .crowd-tab {
    width: 100%;
    
    .crowd-tab-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
      display: flex;
      align-items: center;
      font-weight: bold;
      
      .crowd-tab-name {
        display: inline-block;
        width: 13%;
      }
      
      .crowd-tab-sm {
        display: inline-block;
        width: 87%;
        color: #666;
        flex: 1;
      }
    }
    
    .crowd-tab-middle {
      padding: 15px 0 15px 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
      flex-wrap: wrap;
      
      .crowd-tab-name {
        display: inline-block;
        width: 13%;
        
        &.nameAlign {
          display: flex;
          align-items: flex-start;
          padding-top: 5px;
        }
      }
      
      .crowd-tab-sm {
        display: inline-block;
        width: 87%;
        color: #666;
        flex: 1;
        
        &.descbox {
          display: flex;
          justify-items: center;
          align-items: center;
          flex-wrap: wrap;
        }
      }
    }
  }
  
  .overHiddle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 2px;
    width: 96%;
    border: none;
    text-align: left;
    display: inline-block;
    margin-left: -8px;
    
    &:hover,
    &:focus {
      color: #666;
      background: #fff;
    }
  }
  
  .dx {
    width: 100%;
    margin-top: 10px;
  }
  
  .orangeColor {
    color: #FF7600;
  }
}
</style>


